'use strict';
module.exports = [
  {
    symbol: 'Abu',
    name: '2-Aminobutyric acid diradical',
    mf: 'C4H7NO',
    kind: '',
    ocl: { value: 'dazHPBPOEgEInVZjcH@', coordinates: '!Bb@I~@Ha}_c~H@m]}bGt' },
    mass: 85.10463700109551,
    monoisotopicMass: 85.05276384961,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Acet',
    name: 'Acetyl',
    mf: 'C2H3O',
    kind: '',
    ocl: { value: 'gCaHDEeIi`@', coordinates: '!BbOq~@Ha}' },
    mass: 43.04469897995611,
    monoisotopicMass: 43.01838971626,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'H', number: 3 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Acm',
    name: 'Acetamidomethyl',
    mf: 'C3H6NO',
    kind: '',
    ocl: { value: 'gGYHDPliJuS@@', coordinates: '!BbOrH_Xc|_`BH_P' },
    mass: 72.08596035030448,
    monoisotopicMass: 72.04493881738,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Adao',
    name: 'Adamantyloxy',
    mf: 'C10H15O',
    kind: '',
    ocl: {
      value: 'dc\\H`HAYRVeV^dUGZjjjj@@',
      coordinates: '!B]BOXN`EP}CdB\\tbZ@Ijh~hRELdOBBp',
    },
    mass: 151.2258752025074,
    monoisotopicMass: 151.11229010302,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 15 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Aib',
    name: 'alpha-Aminoisobutyric acid diradical',
    mf: 'C4H7NO',
    kind: '',
    ocl: { value: 'dazHPBPOGgEInfZj@@', coordinates: '!Bb@I~@Ha}b@K|uwwWbGt' },
    mass: 85.10463700109551,
    monoisotopicMass: 85.05276384961,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Ala',
    name: 'Alanine diradical',
    mf: 'C3H5NO',
    kind: 'aa',
    oneLetter: 'A',
    alternativeOneLetter: 'α',
    ocl: { value: 'gNyDBaxmqR[fZjZ@', coordinates: '!Bb@I~@Hb}b@I~Oxa}' },
    mass: 71.07801959624871,
    monoisotopicMass: 71.03711378515,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Arg',
    name: 'Arginine diradical',
    mf: 'C6H12N4O',
    kind: 'aa',
    oneLetter: 'R',
    alternativeOneLetter: 'ρ',
    ocl: {
      value: 'dkLhPBgSPOEgEInWUijjihr@@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvHHa}b@I~@Ha}',
    },
    mass: 156.18592219918227,
    monoisotopicMass: 156.10111102405,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 4 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Argp',
    name: 'Arginine triradical',
    mf: 'C6H11N4O',
    kind: '',
    ocl: {
      value: 'dglhpHpil@gWDEI[UYZfjji`T@',
      coordinates: '!BbGvHGx@bGvH@ha}bOrH_Wxb@KW_Wx@bGt',
    },
    mass: 155.1779814451265,
    monoisotopicMass: 155.09328599182,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 4 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Asn',
    name: 'Asparagine diradical',
    mf: 'C4H6N2O2',
    kind: 'aa',
    oneLetter: 'N',
    alternativeOneLetter: 'η',
    ocl: {
      value: 'deeDPBeACqYqR[ezZjZL`@',
      coordinates: '!BbGu~Ox`B_`BH_X`Bb@I~@Ha}',
    },
    mass: 114.10280438280381,
    monoisotopicMass: 114.04292744137999,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Asnp',
    name: 'Asparagine triradical',
    mf: 'C4H5N2O2',
    kind: '',
    ocl: {
      value: 'dmUDpH[E@IEqgqRVvVijjXi@@',
      coordinates: '!Bb@JH_Wxb@JH_Wxb@KW_Wx@bGt',
    },
    mass: 113.09486362874803,
    monoisotopicMass: 113.03510240915,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Asp',
    name: 'Aspartic acid diradical',
    mf: 'C4H5NO3',
    kind: 'aa',
    oneLetter: 'D',
    alternativeOneLetter: 'δ',
    ocl: {
      value: 'defLPBPYCqYqR[ezZjZL`@',
      coordinates: '!BbGu~Ox`B_`BH_X`Bb@I~@Ha}',
    },
    mass: 115.08756534162052,
    monoisotopicMass: 115.02694302429,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Aspp',
    name: 'Aspartic acid triradical',
    mf: 'C4H4NO3',
    kind: '',
    ocl: {
      value: 'dmVLpFcE@IEqgqRVvVijjXi@@',
      coordinates: '!Bb@JH_Wxb@JH_Wxb@KW_Wx@bGt',
    },
    mass: 114.07962458756472,
    monoisotopicMass: 114.01911799206,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 4 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Asu',
    name: 'alpha-Aminosuberic acid diradical',
    mf: 'C8H13NO3',
    kind: '',
    ocl: {
      value: 'dgnLPBP{CqYqR[euVfjjihr@@',
      coordinates: '!BbGu~Ox`B_`BH_Xc|bOrH_X`BbGvHGx@bGt',
    },
    mass: 171.19403496100773,
    monoisotopicMass: 171.08954328213002,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Asup',
    name: 'alpha-Aminosuberic acid triradical',
    mf: 'C8H12NO3',
    kind: '',
    ocl: {
      value: 'do^LpEcG@IMqoqRVuUejZjjibT@',
      coordinates: '!BbOrH_Wxb@JH_Xc|bGvHHa}_c~H@m]}_`BH_P',
    },
    mass: 170.18609420695194,
    monoisotopicMass: 170.0817182499,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Boc',
    name: 't-Butoxycarbonyl',
    mf: 'C5H9O2',
    kind: '',
    ocl: { value: 'daxD`DpEeImjZj@@', coordinates: '!B|Ou~_A||Ow}mC}_O@' },
    mass: 101.12395611881479,
    monoisotopicMass: 101.06025452921,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Bom',
    name: 'Benzyloxymethyl',
    mf: 'C8H9O',
    kind: '',
    ocl: {
      value: 'deTH`DAYRUYTYj`@@@',
      coordinates: '!B|Gsp__A||Owp_Gy|Gwp_Wy',
    },
    mass: 121.15675888470227,
    monoisotopicMass: 121.06533990964,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Brz',
    name: '2-Bromobenzyloxycarbonyl',
    mf: 'C8H6BrO2',
    kind: '',
    ocl: {
      value: 'dcLDPDpEd\\QImYgWYjB@@@',
      coordinates: '!Bb@I~@Hb}b@JH_X`B_c}~@Hb}bGu~Op',
    },
    mass: 214.03586932736317,
    monoisotopicMass: 212.95511703252,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 6 },
      { symbol: 'Br', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Bu',
    name: 'Butyl',
    mf: 'C4H9',
    kind: '',
    ocl: { value: 'gJPH@liJuP@', coordinates: '!B@Fp@XpAl@FL' },
    mass: 57.114410373442986,
    monoisotopicMass: 57.07042529007,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 9 },
    ],
  },
  {
    symbol: 'Bum',
    name: 't-Butoxymethyl',
    mf: 'C5H11O',
    kind: '',
    ocl: { value: 'gNqHDEeIVjj`@', coordinates: '!B@FL@[@AcXs|@Xvp@' },
    mass: 87.14043270260808,
    monoisotopicMass: 87.08098997409999,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 11 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Bz',
    name: 'Benzoyl',
    mf: 'C7H5O',
    kind: '',
    ocl: {
      value: 'didH`DAYR[e^FX@@@@',
      coordinates: '!BbOq~@Ha}b@I~Oxa}bGu~Op',
    },
    mass: 105.1142599717439,
    monoisotopicMass: 105.03403978072,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 5 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Bzl',
    name: 'Benzyl',
    mf: 'C7H7',
    kind: '',
    ocl: { value: 'daD@`@VTeeVz`@@@', coordinates: '!B|Gsp_A|_gp_A}_g|' },
    mass: 91.13073655553718,
    monoisotopicMass: 91.05477522561,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 7 },
    ],
  },
  {
    symbol: 'Bn',
    name: 'Benzyl',
    mf: 'C7H7',
    kind: '',
    ocl: { value: 'daD@`@VTeeVz`@@@', coordinates: '!B|Gsp_A|_gp_A}_g|' },
    mass: 91.13073655553718,
    monoisotopicMass: 91.05477522561,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 7 },
    ],
  },
  {
    symbol: 'Bzlo',
    name: 'Benzyloxy',
    mf: 'C7H7O',
    kind: '',
    ocl: {
      value: 'didH`HAYRUe^Fh@@@@',
      coordinates: '!B|Gwp_OC}|Gq~_A}|Gu~_p',
    },
    mass: 107.13014147985547,
    monoisotopicMass: 107.04968984518,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Cha',
    name: 'beta-Cyclohexylalanine diradical',
    mf: 'C9H15NO',
    kind: '',
    ocl: {
      value: 'dknHPBPOEgEInWe]NZjjjcH@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvH@gxbGvH_Wx',
    },
    mass: 153.22184251721796,
    monoisotopicMass: 153.11536410745,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Chxo',
    name: 'Cyclohexyloxy',
    mf: 'C6H11O',
    kind: '',
    ocl: { value: 'daDH`HAYRVU[jjj@@', coordinates: '!B|Gsp_A|_gp_A}_g|' },
    mass: 99.15116859934332,
    monoisotopicMass: 99.08098997409999,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Cit',
    name: 'Citrulline diradical',
    mf: 'C6H11N3O2',
    kind: '',
    ocl: {
      value: 'dkODPBdttOEgEInWUijjihr@@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvHHa}b@I~@Ha}',
    },
    mass: 157.170683157999,
    monoisotopicMass: 157.08512660696,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Citp',
    name: 'Citrulline triradical',
    mf: 'C6H10N3O2',
    kind: '',
    ocl: {
      value: 'dgoDpHJ\\l@gWDEI[UYZfjji`T@',
      coordinates: '!BbGvHGx@bGvH@ha}bOrH_Wxb@KW_Wx@bGt',
    },
    mass: 156.16274240394318,
    monoisotopicMass: 156.07730157473,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Clz',
    name: '2-Chlorobenzyloxycarbonyl',
    mf: 'C8H6ClO2',
    kind: '',
    ocl: {
      value: 'dcLDPDpEdXaImYgWYjB@@@',
      coordinates: '!Bb@I~@Hb}b@JH_X`B_c}~@Hb}bGu~Op',
    },
    mass: 169.58527912946118,
    monoisotopicMass: 169.00563211451998,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 6 },
      { symbol: 'Cl', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Cp',
    name: 'Cyclopentadienyl',
    mf: 'C5H5',
    kind: '',
    ocl: { value: 'gFpH@liLimRp@', coordinates: '!B\\OtPThyEGl@fP' },
    mass: 65.09338325395512,
    monoisotopicMass: 65.03912516115,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 5 },
    ],
  },
  {
    symbol: 'Cys',
    name: 'Cysteine diradical',
    mf: 'C3H5NOS',
    kind: 'aa',
    oneLetter: 'C',
    alternativeOneLetter: 'ς',
    ocl: {
      value: 'dazHpBPOEgG`aInVZjcH@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGt',
    },
    mass: 103.14280700237578,
    monoisotopicMass: 103.00918495955,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Cysp',
    name: 'Cysteine triradical',
    mf: 'C3H4NOS',
    kind: '',
    ocl: {
      value: 'diFHHBD@f@agGoEIVVjjfLP@',
      coordinates: '!BbGvHHa}_c~HM]}_`BH_P',
    },
    mass: 102.13486624831998,
    monoisotopicMass: 102.00135992732,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 4 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'D',
    name: 'Deuterium',
    mf: '[2H]',
    kind: '',
    ocl: { value: 'eFAAYhBLCEH@', coordinates: '!B@FL' },
    mass: 2.01410177812,
    monoisotopicMass: 2.01410177812,
    unsaturation: -1,
    elements: [{ symbol: 'H', number: 1, isotope: 2 }],
  },
  {
    symbol: 'Dde',
    name: 'Dde',
    mf: 'C10H13O2',
    kind: '',
    ocl: {
      value: 'dklD`FDEgHhihicIVZfZj@@',
      coordinates: '!Bb@I~@Ha}upJH@m]}_`BH_Wx@b@I}bOrH',
    },
    mass: 165.20939861871415,
    monoisotopicMass: 165.09155465812998,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Dnp',
    name: '2,4-Dinitrophenyl',
    mf: 'C6H3N2O4',
    kind: '',
    ocl: {
      value: 'dkmB`bWatpVRd^VS{HhheEUFfBAbX@@',
      coordinates: '!B_c~H_]]}b@I~Owx_`BH_]]}_c~H_]]}',
    },
    mass: 167.09926376274353,
    monoisotopicMass: 167.00928158383,
    unsaturation: 11,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 3 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 4 },
    ],
  },
  {
    symbol: 'Et',
    name: 'Ethyl',
    mf: 'C2H5',
    kind: '',
    ocl: { value: 'eMBAYRZ@', coordinates: '!B@Fp@Xp' },
    mass: 29.061175563749384,
    monoisotopicMass: 29.03912516115,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'H', number: 5 },
    ],
  },
  {
    symbol: 'Fmoc',
    name: 'Fluorenylmethoxycarbonyl',
    mf: 'C15H11O2',
    kind: '',
    ocl: {
      value: 'fde@b@DX@liMkLrjxeVCzLuT@@@P@@@',
      coordinates: '!BbOq~@Ha}bOrH_]ARcm}Tv~i`pAeKv|@fpB[j[~iozfAKvp',
    },
    mass: 223.24719659427882,
    monoisotopicMass: 223.07590459367,
    unsaturation: 19,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 11 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'For',
    name: 'Formyl',
    mf: 'CHO',
    kind: '',
    ocl: { value: 'eMJDVTfP@', coordinates: '!B@Fp@Xp' },
    mass: 29.018081575109303,
    monoisotopicMass: 29.0027396518,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 1 },
      { symbol: 'H', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Gln',
    name: 'Glutamine diradical',
    mf: 'C5H8N2O2',
    kind: 'aa',
    oneLetter: 'Q',
    alternativeOneLetter: 'ξ',
    ocl: {
      value: 'dmUDPBUICqYqR[evfjihr@@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvHGx@bGt',
    },
    mass: 128.12942178765059,
    monoisotopicMass: 128.05857750584,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 8 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Glnp',
    name: 'Glutamine triradical',
    mf: 'C5H7N2O2',
    kind: '',
    ocl: {
      value: 'dcuDpH{MAYeqWqRVuejZjiad@',
      coordinates: '!BbGvHGx@bGvH@ha}_c~HM]}_`BH_P',
    },
    mass: 127.12148103359483,
    monoisotopicMass: 127.05075247361,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Glp',
    name: 'Pyroglutamine',
    mf: 'C5H5NO2',
    kind: '',
    ocl: {
      value: 'deVDPBRP|V\\TfygxYjjZL`@',
      coordinates: '!Bb@I~@Ha}tEJNwr[@UMo@FXBN',
    },
    mass: 111.09889631403748,
    monoisotopicMass: 111.03202840472,
    unsaturation: 6,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Glu',
    name: 'Glutamic acid diradical',
    mf: 'C5H7NO3',
    kind: 'aa',
    oneLetter: 'E',
    alternativeOneLetter: 'ε',
    ocl: {
      value: 'dmVLPBRUCqYqR[evfjihr@@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvHGx@bGt',
    },
    mass: 129.11418274646732,
    monoisotopicMass: 129.04259308875,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Glup',
    name: 'Glutamic acid triradical',
    mf: 'C5H6NO3',
    kind: '',
    ocl: {
      value: 'dcvLpNcM@IeqWqRVuejZjiad@',
      coordinates: '!BbGvHGx@bGvH@ha}_c~HM]}_`BH_P',
    },
    mass: 128.10624199241153,
    monoisotopicMass: 128.03476805652002,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Gly',
    name: 'Glycine diradical',
    mf: 'C2H3NO',
    kind: 'aa',
    oneLetter: 'G',
    alternativeOneLetter: 'γ',
    ocl: { value: 'gGYDBaxuqR[Yj@@', coordinates: '!BbOq~@Ha}bOrH_P' },
    mass: 57.051402191401905,
    monoisotopicMass: 57.021463720689994,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'H', number: 3 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Hci',
    name: 'Homocitrulline diradical',
    mf: 'C7H13N3O2',
    kind: '',
    ocl: {
      value: 'dgoDPBVtLOEgEInWUZZjjfcH@',
      coordinates: '!BbGu~Ox`B_`BH_Xc|bOrH_X`BbGvHGx@bGt',
    },
    mass: 171.19730056284578,
    monoisotopicMass: 171.10077667142,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Hcip',
    name: 'Homocitrulline triradical',
    mf: 'C7H12N3O2',
    kind: '',
    ocl: {
      value: 'do_DpHI\\\\EdwFEI[UVVijjjfIP@',
      coordinates: '!BbOrH_Wxb@JH_Xc|bGvHHa}_c~H@m]}_`BH_P',
    },
    mass: 170.18935980879002,
    monoisotopicMass: 170.09295163918998,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'His',
    name: 'Histidine diradical',
    mf: 'C6H7N3O',
    kind: 'aa',
    oneLetter: 'H',
    alternativeOneLetter: 'ζ',
    ocl: {
      value: 'dcOHPBGTCqYqR[eyUvZjejL`@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGwPTh{_UMo@FP',
    },
    mass: 137.13951521745759,
    monoisotopicMass: 137.05891185847,
    unsaturation: 8,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Hisp',
    name: 'Histidine triradical',
    mf: 'C6H6N3O',
    kind: '',
    ocl: {
      value: 'dkoHpHHSAYUqwqRY]YXjjVjihy@@',
      coordinates: '!BTmA}bL@fUHRN`H`BbGu~Ox`Buwu~@Ha}',
    },
    mass: 136.13157446340182,
    monoisotopicMass: 136.05108682624,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Hser',
    name: 'Homoserine diradical',
    mf: 'C4H7NO2',
    kind: '',
    ocl: {
      value: 'diFDPBPP|V\\Tfy^Zjhr@@',
      coordinates: '!BbGu~Ox`B_`BH_X`Bb@JH_P',
    },
    mass: 101.10404192541378,
    monoisotopicMass: 101.04767846918,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Hserp',
    name: 'Homoserine triradical',
    mf: 'C4H6NO2',
    kind: '',
    ocl: {
      value: 'defDpJbPV^\\Q|TeVVjji`d@',
      coordinates: '!Bb@JH_X`BbGu~Oxc|uwu~@Ha}',
    },
    mass: 100.09610117135801,
    monoisotopicMass: 100.03985343695001,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Hyp',
    name: 'Hydroxyproline diradical',
    mf: 'C5H7NO2',
    kind: '',
    ocl: {
      value: 'deVDPBRP|V\\\\bfbbOCMUUIdE@@',
      coordinates: '!Bb@I~@Ha}tEJNwr[@UMo@FUJO',
    },
    mass: 113.11477782214904,
    monoisotopicMass: 113.04767846918,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Hypp',
    name: 'Hydroxyproline triradical',
    mf: 'C5H6NO2',
    kind: '',
    ocl: {
      value: 'dmvDpJaPB^\\Y|TeeWjZjjidRL`@',
      coordinates: '!BBOpH_UARcc}TNtBY@HyRSpCQDr\\',
    },
    mass: 112.10683706809326,
    monoisotopicMass: 112.03985343695001,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Ile',
    name: 'Isoleucine diradical',
    mf: 'C6H11NO',
    kind: 'aa',
    oneLetter: 'I',
    alternativeOneLetter: 'ι',
    ocl: {
      value: 'defHPBPOEgEInVyjjdrT`@',
      coordinates: '!BbGu~Oxc|_`BH_Xc|b@I~Oxa}',
    },
    mass: 113.15787181078912,
    monoisotopicMass: 113.08406397853,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Ivdde',
    name: '1-[4,4-dimethyl-2,6-dioxocyclohexylidene)-3-methylbutyl',
    mf: 'C13H19O2',
    kind: '',
    ocl: {
      value: 'f`a@b@NR@lyEEDhhigEVfjYjj`@@',
      coordinates: '!BbOq~@Ha}urHGxuwu~@Ha}_`CW_Xa}bOq}b@JH',
    },
    mass: 207.28925083325453,
    monoisotopicMass: 207.13850485151,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 19 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Leu',
    name: 'Leucine diradical',
    mf: 'C6H11NO',
    kind: 'aa',
    oneLetter: 'L',
    alternativeOneLetter: 'λ',
    ocl: {
      value: 'defHPBPOEgEInWijjhr@@',
      coordinates: '!BbGu~Ox`B_`BH_X`Bb@I~@Ha}',
    },
    mass: 113.15787181078912,
    monoisotopicMass: 113.08406397853,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Lys',
    name: 'Lysine diradical',
    mf: 'C6H12N2O',
    kind: 'aa',
    oneLetter: 'K',
    alternativeOneLetter: 'κ',
    ocl: {
      value: 'dmUHPBU@|V\\Tfy]YjjjL`@',
      coordinates: '!BbGu~Ox`B_`BHoX`Bb@JH_X`BbKt',
    },
    mass: 128.17251577629068,
    monoisotopicMass: 128.09496301519,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Lysp',
    name: 'Lysine triradical',
    mf: 'C6H11N2O',
    kind: '',
    ocl: {
      value: 'dcuHpH{PVY\\U|TeUYZjjjXY@@',
      coordinates: '!Bb@JH_X`BbGvH@ha}_c~H@m]}_`BH_P',
    },
    mass: 127.16457502223491,
    monoisotopicMass: 127.08713798295999,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Mbh',
    name: "4,4'-Dimethoxybenzhydryl",
    mf: 'C15H15O2',
    kind: '',
    ocl: {
      value: 'fdy@b@G^@liLsJkzlcZmT@@@UP@@@',
      coordinates: '!BbGvHGx_`BH_Xa}uwvHHc|_c}~Oxa}uwvHGxbGwW_P',
    },
    mass: 227.27895961050194,
    monoisotopicMass: 227.10720472258998,
    unsaturation: 15,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 15 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Me',
    name: 'Methyl',
    mf: 'CH3',
    kind: '',
    ocl: { value: 'eFBAYc@@', coordinates: '!B@FL' },
    mass: 15.03455815890258,
    monoisotopicMass: 15.02347509669,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 1 },
      { symbol: 'H', number: 3 },
    ],
  },
  {
    symbol: 'Mebzl',
    name: '4-Methylbenzyl',
    mf: 'C8H9',
    kind: '',
    ocl: {
      value: 'did@`@VTee]nh@H@@',
      coordinates: '!B|Gsp__A|_gp_C}_gp_P',
    },
    mass: 105.15735396038399,
    monoisotopicMass: 105.07042529007,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 9 },
    ],
  },
  {
    symbol: 'Meobzl',
    name: '4-Methoxybenzyl',
    mf: 'C8H9O',
    kind: '',
    ocl: {
      value: 'deTH`AAYRVUunh@J@@',
      coordinates: '!B|Gsp__A|_gp_A}_gp_Wy',
    },
    mass: 121.15675888470227,
    monoisotopicMass: 121.06533990964,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Met',
    name: 'Methionine diradical',
    mf: 'C5H9NOS',
    kind: 'aa',
    oneLetter: 'M',
    alternativeOneLetter: 'μ',
    ocl: {
      value: 'defHpBPOEgDPaInWYjjhr@@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvHHa}',
    },
    mass: 131.19604181206938,
    monoisotopicMass: 131.04048508847,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mmt',
    name: '4-Methoxytrityl',
    mf: 'C20H17O',
    kind: '',
    ocl: {
      value: 'ffcAB@B`V\\bdTTTRRRVvIhnRGMT@@@@AP@@@',
      coordinates:
        '!BbKvHM^}_c}~@Hb}dXWHb}j|nHHc|AqOWoWxJV^Ho]\\BuwvHHb}',
    },
    mass: 273.3491156779715,
    monoisotopicMass: 273.12794016748,
    unsaturation: 23,
    elements: [
      { symbol: 'C', number: 20 },
      { symbol: 'H', number: 17 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Mtc',
    name: '2,2,5,7,8-pentamethylchroman-6-sulphonyl',
    mf: 'C14H19O3S',
    kind: '',
    ocl: {
      value: 'fleAa@DX\\AY`DYEHXhhilmiKW`rpDQUUD@@',
      coordinates: '!BbGtBbGwWbGvHGxbGu~@Ha}uwu~Ox`B_c~H_Xa}b@H@_osW',
    },
    mass: 267.36417906043516,
    monoisotopicMass: 267.10549064548,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 14 },
      { symbol: 'H', number: 19 },
      { symbol: 'O', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mtr',
    name: '4-Methoxy-2,3,6-trimethylbenzenesulphonyl',
    mf: 'C10H13O3S',
    kind: '',
    ocl: {
      value: 'do|LPDrpVXBLbdLTTTngYXBHj@@',
      coordinates: '!BbOq}b@KWb@I~@Ha}bOsWHc|_c~H_Wx@b@JH_P',
    },
    mass: 213.27359094915948,
    monoisotopicMass: 213.05854045209998,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'O', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mts',
    name: 'Mesitylene-2-sulphonyl',
    mf: 'C9H11O2S',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 183.24756861999438,
    monoisotopicMass: 183.04797576807,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'O', number: 2 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mtt',
    name: '4-Methyltrityl',
    mf: 'C20H17',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 257.3497107536532,
    monoisotopicMass: 257.13302554791,
    unsaturation: 23,
    elements: [
      { symbol: 'C', number: 20 },
      { symbol: 'H', number: 17 },
    ],
  },
  {
    symbol: 'Nle',
    name: 'Norleucine diradical',
    mf: 'C6H11NO',
    kind: '',
    ocl: {
      value: 'defHPBPOEgEInWYjjhr@@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvHHa}',
    },
    mass: 113.15787181078912,
    monoisotopicMass: 113.08406397853,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Npys',
    name: '3-Nitro-2-pyridinesulphenyl',
    mf: 'C5H3N2O2S',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 155.1545054234988,
    monoisotopicMass: 154.99152351908998,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 3 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Nva',
    name: 'Norvaline diradical',
    mf: 'C5H9NO',
    kind: '',
    ocl: {
      value: 'diFHPBPOEgEInWfjjL`@',
      coordinates: '!BbGu~Ox`B_`BH_X`Bb@JH_P',
    },
    mass: 99.13125440594231,
    monoisotopicMass: 99.06841391407,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Odmab',
    name: 'Odmab',
    mf: 'C20H26NO3',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 328.4260955245558,
    monoisotopicMass: 328.19126870111995,
    unsaturation: 15,
    elements: [
      { symbol: 'C', number: 20 },
      { symbol: 'H', number: 26 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Orn',
    name: 'Ornithine diradical',
    mf: 'C5H10N2O',
    kind: '',
    ocl: {
      value: 'deeHPBe@|V\\Tfy]fjjcH@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvHHa}',
    },
    mass: 114.14589837144388,
    monoisotopicMass: 114.07931295072999,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Ornp',
    name: 'Ornithine triradical',
    mf: 'C5H9N2O',
    kind: '',
    ocl: {
      value: 'dmUHpHYPBQ\\Y|TeUejjjfJP@',
      coordinates: '!BbGvHHa}b@JH_Wxb@KW_Wx@bGt',
    },
    mass: 113.13795761738811,
    monoisotopicMass: 113.0714879185,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Pbf',
    name: '2,2,4,6,7-pentamethyldihydrobenzofurane-5-sulfonyl',
    mf: 'C13H17O3S',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 253.33756165558833,
    monoisotopicMass: 253.08984058101998,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 17 },
      { symbol: 'O', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Pen',
    name: 'Penicillamine diradical',
    mf: 'C5H9NOS',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 131.19604181206938,
    monoisotopicMass: 131.04048508847,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Penp',
    name: 'Penicillamine triradical',
    mf: 'C5H8NOS',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 130.1881010580136,
    monoisotopicMass: 130.03266005624,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 8 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Ph',
    name: 'Phenyl',
    mf: 'C6H5',
    kind: '',
    ocl: { value: 'gOpH@liLkW@@@@', coordinates: '!B|Owp_Gy|OwpWy' },
    mass: 77.10411915069038,
    monoisotopicMass: 77.03912516115,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 5 },
    ],
  },
  {
    symbol: 'Phe',
    name: 'Phenylalanine diradical',
    mf: 'C9H9NO',
    kind: 'aa',
    oneLetter: 'F',
    alternativeOneLetter: 'φ',
    ocl: {
      value: 'dknHPBPOEgEInWe]NZj@@cH@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGvH@gxbGvH_Wx',
    },
    mass: 147.1741979928833,
    monoisotopicMass: 147.06841391407002,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Phepcl',
    name: '4-Chlorophenylalanine diradical',
    mf: 'C9H8ClNO',
    kind: '',
    ocl: {
      value: 'dg^HpBPOEgFxaInWe_Sfj`@bL`@',
      coordinates: '!BbOq~@Ha}_c~H@m]}bGvH@gxbGvH_WxbGt',
    },
    mass: 181.6191948214355,
    monoisotopicMass: 181.02944156384,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 8 },
      { symbol: 'Cl', number: 1 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Phg',
    name: 'Phenylglycine',
    mf: 'C8H7NO',
    kind: '',
    ocl: {
      value: 'dcNHPBPOEgEInVuWYj`@Hr@@',
      coordinates: '!BbOq~@Ha}b@I~Oxa}bGwW_Wx_cW_P',
    },
    mass: 133.1475805880365,
    monoisotopicMass: 133.05276384961002,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Pmc',
    name: '2,2,5,7,8-Pentamethylchroman-6-sulphonyl',
    mf: 'C14H19O3S',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 267.36417906043516,
    monoisotopicMass: 267.10549064548,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 14 },
      { symbol: 'H', number: 19 },
      { symbol: 'O', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Pro',
    name: 'Proline diradical',
    mf: 'C5H7NO',
    kind: 'aa',
    oneLetter: 'P',
    alternativeOneLetter: 'π',
    ocl: {
      value: 'difHPBPOEgEInYxYjjhr@@',
      coordinates: '!Bb@I~@Ha}tEJNwr[@UMo@FP',
    },
    mass: 97.11537289783075,
    monoisotopicMass: 97.05276384961,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Pyr',
    name: 'Pyroglutamine',
    mf: 'C5H5NO2',
    kind: '',
    ocl: {
      value: 'deVDPBRP|V\\TfygxYjjZL`@',
      coordinates: '!Bb@I~@Ha}tEJNwr[@UMo@FXBN',
    },
    mass: 111.09889631403748,
    monoisotopicMass: 111.03202840472,
    unsaturation: 6,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Sar',
    name: 'Sarcosine diradical',
    mf: 'C3H5NO',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 71.07801959624871,
    monoisotopicMass: 71.03711378515,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Ser',
    name: 'Serine diradical',
    mf: 'C3H5NO2',
    kind: 'aa',
    oneLetter: 'S',
    alternativeOneLetter: 'σ',
    ocl: {
      value: 'dazDPBS`|V\\TfyYjjL`@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}bGt',
    },
    mass: 87.07742452056698,
    monoisotopicMass: 87.03202840472,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Serp',
    name: 'Serine triradical',
    mf: 'C3H4NO2',
    kind: '',
    ocl: {
      value: 'diFDpB`PBV\\^|TeYZjjXq@@',
      coordinates: '!BbGvHHa}_c~HM]}_`BH_P',
    },
    mass: 86.06948376651121,
    monoisotopicMass: 86.02420337249,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 4 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Sta',
    name: 'Statine diradical',
    mf: 'C8H15NO2',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 157.210511544801,
    monoisotopicMass: 157.11027872702002,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Stap',
    name: 'Statine triradical',
    mf: 'C8H14NO2',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 156.2025707907452,
    monoisotopicMass: 156.10245369479,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Tacm',
    name: 'Trimethylacetamidomethyl',
    mf: 'C6H12NO',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 114.16581256484488,
    monoisotopicMass: 114.09188901076,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Tbdms',
    name: 't-Butyldimethylsilyl',
    mf: 'C6H15Si',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 115.2690253969541,
    monoisotopicMass: 115.09430201810001,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 15 },
      { symbol: 'Si', number: 1 },
    ],
  },
  {
    symbol: 'Tbu',
    name: 't-Butyl',
    mf: 'C4H9',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 57.114410373442986,
    monoisotopicMass: 57.07042529007,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 9 },
    ],
  },
  {
    symbol: 'Tbuo',
    name: 't-Butoxy',
    mf: 'C4H9O',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 73.11381529776126,
    monoisotopicMass: 73.06533990964,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Tbuthio',
    name: 't-Butylthio',
    mf: 'C4H9S',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 89.17919777957005,
    monoisotopicMass: 89.04249646446999,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 9 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Tfa',
    name: 'Trifluoroacetyl',
    mf: 'C2F3O',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 97.01608620597878,
    monoisotopicMass: 96.99012410776,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'F', number: 3 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Thr',
    name: 'Threonine diradical',
    mf: 'C4H7NO2',
    kind: 'aa',
    oneLetter: 'T',
    alternativeOneLetter: 'τ',
    ocl: { value: 'd@', coordinates: '' },
    mass: 101.10404192541378,
    monoisotopicMass: 101.04767846918,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Thrp',
    name: 'Threonine triradical',
    mf: 'C4H6NO2',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 100.09610117135801,
    monoisotopicMass: 100.03985343695001,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Tfsi',
    name: '(Bis)(trifluoromethanesulfonyl)imide',
    mf: 'C2F6NO4S2',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 280.1457884908235,
    monoisotopicMass: 279.91729380789,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'F', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 4 },
      { symbol: 'S', number: 2 },
    ],
  },
  {
    symbol: 'Tips',
    name: 'Triisopropylsilyl',
    mf: 'C9H21Si',
    kind: '',
    ocl: {
      value: 'dmT@P@VX\\DffYjjjh@@',
      coordinates: '!B_a@gHb\\]FBIuWxP^zi~KwxPFAt',
    },
    mass: 157.34887761149452,
    monoisotopicMass: 157.14125221148,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 21 },
      { symbol: 'Si', number: 1 },
    ],
  },
  {
    symbol: 'Tms',
    name: 'Trimethylsilyl',
    mf: 'C3H9Si',
    kind: '',
    ocl: { value: 'gJPD@lqpRZj`@', coordinates: '!BbOq~@GxbGt' },
    mass: 73.1891731824137,
    monoisotopicMass: 73.04735182472,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 9 },
      { symbol: 'Si', number: 1 },
    ],
  },
  {
    symbol: 'Tos',
    name: 'Tosyl',
    mf: 'C7H7O2S',
    kind: '',
    ocl: {
      value: 'dmtDPDpEf@cHiCDeafV@B@@',
      coordinates: '!B|Ou||Ovw|Gwp_Gy|GwpWy|Gt',
    },
    mass: 155.1943338103008,
    monoisotopicMass: 155.01667563914998,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 2 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Trp',
    name: 'Tryptophan diradical',
    mf: 'C11H10N2O',
    kind: 'aa',
    oneLetter: 'W',
    alternativeOneLetter: 'ω',
    ocl: {
      value: 'f`qQA@BFPCqXxiMr|rnhsoSUTa@QCD@@',
      coordinates: '!BbOq~@Ha}_c~H@m]}bGwPTh{_UMojXL@YpB[@Ini`',
    },
    mass: 186.21031375185538,
    monoisotopicMass: 186.07931295073,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Trpp',
    name: 'Tryptophan triradical',
    mf: 'C11H9N2O',
    kind: '',
    ocl: {
      value: 'fhiQC@HFB@I\\x~|TfYU_ebLDjhDHjibFd@',
      coordinates: '!BTmA}bL@fUHR_Ihz@iVBeXHc|grZH_WxbOsW_Wx@bGt',
    },
    mass: 185.20237299779959,
    monoisotopicMass: 185.07148791850003,
    unsaturation: 15,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Trt',
    name: 'Trityl',
    mf: 'C19H15',
    kind: '',
    ocl: {
      value: 'fbm@B@@KJSSLrjkyhnRGMT@@@@@@@@',
      coordinates: '!BrHI~PGy_rMvW@l`BQCvWw\\bBAg}~PGy@]i}~W|c]cNwH`i_]_e|',
    },
    mass: 243.32309334880637,
    monoisotopicMass: 243.11737548345,
    unsaturation: 23,
    elements: [
      { symbol: 'C', number: 19 },
      { symbol: 'H', number: 15 },
    ],
  },
  {
    symbol: 'Tyr',
    name: 'Tyrosine diradical',
    mf: 'C9H9NO2',
    kind: 'aa',
    oneLetter: 'Y',
    alternativeOneLetter: 'ψ',
    ocl: {
      value: 'dg^DPBRp|V\\Tfy^U}NZj@BHr@@',
      coordinates: '!BbOq~@Ha}_c~H@m]}bGvH@gxbGvH_WxbGt',
    },
    mass: 163.1736029172016,
    monoisotopicMass: 163.06332853364,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Tyrp',
    name: 'Tyrosine triradical',
    mf: 'C9H8NO2',
    kind: '',
    ocl: {
      value: 'do~DpEapBS\\[|Tee]YYnh@JjdbT@',
      coordinates: '!B_`BHGx@bGvH@h`BbKvH@ha}_c~H@m]}_`BHoP',
    },
    mass: 162.16566216314578,
    monoisotopicMass: 162.05550350141,
    unsaturation: 11,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 8 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Val',
    name: 'Valine',
    mf: 'C5H9NO',
    kind: 'aa',
    oneLetter: 'V',
    alternativeOneLetter: 'ν',
    ocl: {
      value: 'diFHPBPOEgEInVfjjL`@',
      coordinates: '!Bb@I~@Ha}_c~H@m]}_`BH_P',
    },
    mass: 99.13125440594231,
    monoisotopicMass: 99.06841391407,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Valoh',
    name: 'beta-Hydroxyvaline diradical',
    mf: 'C5H9NO2',
    kind: '',
    ocl: {
      value: 'defDPBS`|V\\TfyZfjjcH@',
      coordinates: '!Bb@I~@Ha}b@I~Oxa}Owy~OpA~',
    },
    mass: 115.13065933026058,
    monoisotopicMass: 115.06332853364,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Valohp',
    name: 'beta-Hydroxyvaline triradical',
    mf: 'C5H8NO2',
    kind: '',
    ocl: {
      value: 'dmVDpFaPBQ\\Y|\\bTbaTjjjXq@@',
      coordinates: '!BbGvHHa}_Xc|bGxb@KW_Wx@bGt',
    },
    mass: 114.1227185762048,
    monoisotopicMass: 114.05550350141002,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 8 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Xan',
    name: 'Xanthyl',
    mf: 'C13H9O',
    kind: '',
    ocl: { value: 'd@', coordinates: '' },
    mass: 181.21043836837848,
    monoisotopicMass: 181.06533990964002,
    unsaturation: 17,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Z',
    name: 'Benzyloxycarbonyl',
    mf: 'C8H7O2',
    kind: '',
    ocl: {
      value: 'dmtD`DpEeImYVUfh@@@@',
      coordinates: '!Bb@I~@Ha}b@JH_Xc|_c~H_Xa}_c|',
    },
    mass: 135.14028230090898,
    monoisotopicMass: 135.04460446475,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Damp',
    name: 'Desoxyadenosine monophosphate diradical',
    mf: 'C10H12N5O5P',
    kind: 'DNAp',
    oneLetter: 'A',
    alternativeOneLetter: 'α',
    ocl: {
      value: 'fnsiS@IASUlJB]xGbkplxyDhhldhiEEUeSdTekUUUULBATXPlKd@@',
      coordinates:
        '!Bqc}{JxyO|XoSWC}W]poGQ\\Ou}]rmx\\Ou}]{qpza|qb}MJwlk^sFO|X',
    },
    mass: 313.2069506932622,
    monoisotopicMass: 313.05760550518,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 5 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dcmp',
    name: 'Desoxycytidine monophosphate diradical',
    mf: 'C9H12N3O6P',
    kind: 'DNAp',
    oneLetter: 'C',
    alternativeOneLetter: 'ς',
    ocl: {
      value: 'fjmps@IQKB`g^BCqUxV\\\\bTTVRTTbb^iqNZjjjifVkBEa\\`@',
      coordinates: '!Bqc}{JxyO|XoSWA}_W]poGQ\\GuMKuMh\\Gu}]{qpSF]tWQTvatP',
    },
    mass: 289.18221329795364,
    monoisotopicMass: 289.04637211589,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dgmp',
    name: 'Desoxyguanosine monophosphate diradical',
    mf: 'C10H12N5O6P',
    kind: 'DNAp',
    oneLetter: 'G',
    alternativeOneLetter: 'γ',
    ocl: {
      value: 'fakhs@IASUlJB]{hOEWaYqrIQQYIQRJJkQTyEIZuUUUSRtsUaBpnP@',
      coordinates:
        '!Bqc}{JxyO|XoSWA}W]poGQ\\Gu}]rmx\\Ou}]{qpza|qb}MJwlk^sFza|q`',
    },
    mass: 329.20635561758047,
    monoisotopicMass: 329.05252012475,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dtmp',
    name: 'Desoxythymidine monophosphate diradical',
    mf: 'C10H13N2O7P',
    kind: 'DNAp',
    oneLetter: 'T',
    alternativeOneLetter: 'τ',
    ocl: {
      value: 'ff}Qs@IQaPSoAjCqUxV\\\\bTTVRTTbbZUNIsUUUULsSVDKBy@@',
      coordinates:
        '!Bqc}{JxyO|XoSWC}_W]poGQ\\GuMKuMh\\Gu}]{qpSF]tWQTvaSZGQ',
    },
    mass: 304.1935916616171,
    monoisotopicMass: 304.04603776326,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dump',
    name: 'Desoxyuridine monophosphate diradical',
    mf: 'C9H11N2O7P',
    kind: 'DNAp',
    oneLetter: 'U',
    alternativeOneLetter: 'υ',
    ocl: {
      value: 'fjmQs@IQaPSoAJCqUxV\\\\bTTVRTTbb^iqNZjjjifYkBEa\\`@',
      coordinates: '!Bqc}{JxyO|XoSWA}_W]poGQ\\GuMKuMh\\Gu}]{qpSF]tWQTvatP',
    },
    mass: 290.1669742567703,
    monoisotopicMass: 290.0303876988,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Drmp',
    name: 'Desoxyribose monophosphate diradical',
    mf: 'C5H7O5P',
    kind: 'DNAp',
    ocl: { value: 'd@', coordinates: '' },
    mass: 178.08005138207807,
    monoisotopicMass: 178.00311032188,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 5 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dadp',
    name: 'Desoxyadenosine diphosphate diradical',
    mf: 'C10H13N5O8P2',
    kind: 'DNApp',
    oneLetter: 'A',
    ocl: {
      value: 'fmwhH`IASM\\JBl{wQ`|U^F_AkbdlsjsSOoRtyEMYuUUUM@pSEQaBpnP@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGu}utnDM^HGwWzf~_Ih}M_`AKvto[_`@_`A~grZ_I`',
    },
    mass: 393.1868682186928,
    monoisotopicMass: 393.02393639454,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Dcdp',
    name: 'Desoxycytidine diphosphate diradical',
    mf: 'C9H13N3O9P2',
    kind: 'DNApp',
    oneLetter: 'C',
    ocl: {
      value: 'fikqH`IQGB`kN|EoP^JoCOaUqrIQQYIQRJKGRJgDejjjjZYfZkBEa\\`@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGuMcqLX@m^H@gwWKB__t]Q_`@SFGx@Owx@_mQ',
    },
    mass: 369.16213082338425,
    monoisotopicMass: 369.01270300525005,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Dgdp',
    name: 'Desoxyguanosine diphosphate diradical',
    mf: 'C10H13N5O9P2',
    kind: 'DNApp',
    oneLetter: 'G',
    ocl: {
      value: 'fcoiH`IASM\\JBl{wQ{Axj|L~CWEIYgUff_^fZ\\bflzjjjfiZifZlHVEr@@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGu}utnD@m^H@gwWzf~_Ih}M_`AKvto[_`@_`A~gr[j[y|f',
    },
    mass: 409.186273143011,
    monoisotopicMass: 409.01885101411,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Dtdp',
    name: 'Desoxythymidine diphosphate diradical',
    mf: 'C10H14N2O10P2',
    kind: 'DNApp',
    oneLetter: 'T',
    ocl: {
      value: 'fe{Ph`IQaPUg^Ct\\p^JoCO`uqrIQQYIQRJKEJQTxdmUUUSSMTsVDKBy@@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^HMQbGuMcqLX@m^H@gwWKB__t]Q_`@SFALX_`@_`A~w}D',
    },
    mass: 384.1735091870477,
    monoisotopicMass: 384.01236865262,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Dudp',
    name: 'Desoxyuridine diphosphate diradical',
    mf: 'C9H12N2O10P2',
    kind: 'DNApp',
    oneLetter: 'U',
    ocl: {
      value: 'fikPh`IQaPUg^Bwhp^JoCOaUqrIQQYIQRJKGRJgDejjjjZYjYkBEa\\`@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGuMcqLX@m^H@gwWKB__t]Q_`@SFGx@Owx@_mQ',
    },
    mass: 370.1468917822009,
    monoisotopicMass: 369.99671858816,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Datp',
    name: 'Desoxyadenosine triphosphate diradical',
    mf: 'C10H14N5O11P3',
    kind: 'DNAppp',
    oneLetter: 'A',
    ocl: {
      value:
        'eohZMJ@I@diehJAKGOFnakg`OESpr|Mo@yqrIQQYIQRJKYZQKVRcbIJjZjjjihFAhjZcAAXKb@@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGu}utnDM^H@gwWzf~_Ih}M_`AKvto[@hcW@`A~grZ_Igx@_`@@_c}~',
    },
    mass: 473.16678574412344,
    monoisotopicMass: 472.9902672839,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Dctp',
    name: 'Desoxycytidine triphosphate diradical',
    mf: 'C9H14N3O12P3',
    kind: 'DNAppp',
    oneLetter: 'C',
    ocl: {
      value:
        'fkopZ`IQGB`kN|Fk^{NCqUxY|I~BwGHeEEdeEHhl]HlYJ\\RVjjjiifVjfkBEa\\`@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGuMcqLX@m^H@gwWKB__t]Q_`@SFOrHupH@_mQ_`A~@@A~Owx',
    },
    mass: 449.14204834881485,
    monoisotopicMass: 448.97903389461004,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 12 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Dgtp',
    name: 'Desoxyguanosine triphosphate diradical',
    mf: 'C10H14N5O12P3',
    kind: 'DNAppp',
    oneLetter: 'G',
    ocl: {
      value:
        'e`TZCJ@I@diehJAKGOFnamgo`OESpr|CoByqrIQQYIQRJKYZQQYrT\\QIUSUUUUMRuMLtuVBBpWD@@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGu}utnD@m^H@gwWzf~_Ih}M_`AKvto[@hcW@`A~gr[j[y|f_`A~@@A~Owx',
    },
    mass: 489.16619066844174,
    monoisotopicMass: 488.98518190347005,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 12 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Dttp',
    name: 'Desoxythymidine triphosphate diradical',
    mf: 'C10H15N2O13P3',
    kind: 'DNAppp',
    oneLetter: 'T',
    ocl: {
      value:
        'fgQZ`IQaPUg^BwhygnCqUxY|E~FwGHeEEdeEHhlTiDSISbRuUUUMLuMMMVDKBy@@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGuMcqLX@m^H@gwWKB__t]Q_`@SFALXHcW@`A~w}E~@Gx@@Gx_`',
    },
    mass: 464.15342671247834,
    monoisotopicMass: 463.97869954198,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Dutp',
    name: 'Desoxyuridine triphosphate diradical',
    mf: 'C9H13N2O13P3',
    kind: 'DNAppp',
    oneLetter: 'U',
    ocl: {
      value:
        'fkoQZ`IQaPUg^CUoQ{NCqUxY|I~BwGHeEEdeEHhl]HlYJ\\RVjjjiiffffkBEa\\`@',
      coordinates:
        '!BIi[Rx{_grZOSXa}_]^H@mQbGuMcqLX@m^H@gwWKB__t]Q_`@SFOrHupH@_mQ_`A~@@A~Owx',
    },
    mass: 450.1268093076315,
    monoisotopicMass: 449.96304947752,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Dade',
    name: 'Desoxyadenosine diradical',
    mf: 'C10H11N5O2',
    kind: 'DNA',
    oneLetter: 'A',
    ocl: {
      value: 'fluha@IF]ELJ@|QNJRsN|rntyYpXuUUTBATXPlKd@@',
      coordinates: '!B\\KqpQARcg|T^|X@@Id`zeHo@Ie}]vaLcg|T^qAMDDvN_xy',
    },
    mass: 233.22703316783156,
    monoisotopicMass: 233.09127461582,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 2 },
    ],
  },
  {
    symbol: 'Dcyt',
    name: 'Desoxycytidine diradical',
    mf: 'C9H11N3O3',
    kind: 'DNA',
    oneLetter: 'C',
    ocl: {
      value: 'fhiqa@IVCBa`^HgEIYg^Y~gG^jjjiejpaXWH@',
      coordinates: '!BBOpH_UARcc}TN|Y@PIe`zeIO@MDSIrpXTd}RSqLgTd|',
    },
    mass: 209.202295772523,
    monoisotopicMass: 209.08004122653,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Dgua',
    name: 'Desoxyguanosine diradical',
    mf: 'C10H11N5O3',
    kind: 'DNA',
    oneLetter: 'G',
    ocl: {
      value: 'fbmia@IF]ELJYAxb\\Tef]ye^Z\\lxLZjjjeZfkBEa\\`@',
      coordinates: '!B\\KqpQARcg|T^|X@@Id`zeHo@Ie}]vaLcg|T^qAMDDvN_vaLcg|',
    },
    mass: 249.22643809214986,
    monoisotopicMass: 249.08618923539,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Dthy',
    name: 'Desoxythymidine diradical',
    mf: 'C10H12N2O4',
    kind: 'DNA',
    oneLetter: 'T',
    ocl: {
      value: 'fdyPQ@IVaPtP^HgEIYg^YuiqwjjjjYikBEa\\`@',
      coordinates: '!BBOpH_UARcc}TN|Y@PIe`zeIO@MDSIrpXTd}RSqLgDr]RSp',
    },
    mass: 224.2136741361865,
    monoisotopicMass: 224.07970687390002,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 4 },
    ],
  },
  {
    symbol: 'Dura',
    name: 'Desoxyuridine diradical',
    mf: 'C9H10N2O4',
    kind: 'DNA',
    oneLetter: 'U',
    ocl: {
      value: 'fhiPQ@IVaPpP^HgEIYg^Y~gG^jjjifZpaXWH@',
      coordinates: '!BBOpH_UARcc}TN|Y@PIe`zeIO@MDSIrpXTd}RSqLgTd|',
    },
    mass: 210.1870567313397,
    monoisotopicMass: 210.06405680944,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 4 },
    ],
  },
  {
    symbol: 'Amp',
    name: 'Adenosine monophosphate diradical',
    mf: 'C10H12N5O6P',
    kind: 'RNAp',
    oneLetter: 'A',
    alternativeOneLetter: 'α',
    ocl: {
      value: 'fakhs@INBwlJ\\TgHOFwaEqrIQQSYQJIRIMLyxMVuUUUPLpEPQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtPCQ@@',
    },
    mass: 329.20635561758047,
    monoisotopicMass: 329.05252012475,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Cmp',
    name: 'Cytidine monophosphate diradical',
    mf: 'C9H12N3O7P',
    kind: 'RNAp',
    oneLetter: 'C',
    alternativeOneLetter: 'ς',
    ocl: {
      value: 'ff}qs@I^kBgENSdGc[pbxyDhhilheDiLv\\BVjjjjYfZbHfHQL`@',
      coordinates: '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuP',
    },
    mass: 305.1816182222719,
    monoisotopicMass: 305.04128673546,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Gmp',
    name: 'Guanosine monophosphate diradical',
    mf: 'C10H12N5O7P',
    kind: 'RNAp',
    oneLetter: 'G',
    alternativeOneLetter: 'γ',
    ocl: {
      value: 'fi{is@INBwlJ\\TgHp^MoBKcdRbbfrbTRdR\\SN^CUmUUUUKMSMQDSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtP@gD}D@',
    },
    mass: 345.20576054189877,
    monoisotopicMass: 345.04743474432,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Tmp',
    name: 'Thymidine monophosphate diradical',
    mf: 'C10H13N2O8P',
    kind: 'RNAp',
    oneLetter: 'T',
    alternativeOneLetter: 'τ',
    ocl: {
      value: 'fncPK@I^aSbgIrtGc[pbxyDhhilheDiLjs`RuUUUSLuMDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@',
    },
    mass: 320.1929965859354,
    monoisotopicMass: 320.04095238282997,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ump',
    name: 'Uridine monophosphate diradical',
    mf: 'C9H11N2O8P',
    kind: 'RNAp',
    oneLetter: 'U',
    alternativeOneLetter: 'υ',
    ocl: {
      value: 'ff}PK@I^aSbgIsTGc[pbxyDhhilheDiLv\\BVjjjjYffbHfHQL`@',
      coordinates: '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuP',
    },
    mass: 306.1663791810886,
    monoisotopicMass: 306.02530231837,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Rmp',
    name: 'Ribose monophosphate diradical',
    mf: 'C5H7O6P',
    kind: 'RNAp',
    ocl: { value: 'd@', coordinates: '' },
    mass: 194.07945630639637,
    monoisotopicMass: 193.99802494145,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Adp',
    name: 'Adenosine diphosphate diradical',
    mf: 'C10H13N5O9P2',
    kind: 'RNApp',
    oneLetter: 'A',
    ocl: {
      value:
        'fcoiH`INCt\\J\\UENU{Axv|F~DwGHeEEMeDheHd\\eHsg`u{UUUU@mAEMPQDqBId@@',
      coordinates:
        '!BvuPfpDnDtEK_t_rHtXBH_TwPbOr_IorHbGtgD}F@RxPBuxc|_]^OTh}R_`CQ`MF@_`@_`A~',
    },
    mass: 409.186273143011,
    monoisotopicMass: 409.01885101411,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Cdp',
    name: 'Cytidine diphosphate diradical',
    mf: 'C9H13N3O10P2',
    kind: 'RNApp',
    oneLetter: 'C',
    ocl: {
      value: 'fe{ph`I^[BgENbgHy`|[^E_CkcdRbbfrbTRdqrdYpIZjjjieijZbHfHQL`@',
      coordinates:
        '!BvuPfpDnDtEK_t_rHtXBH_TwPb@K_cbpXbKtSItwPS]@Bux`Bo]\\lFGx@S]A~@C}~@Gx',
    },
    mass: 385.1615357477025,
    monoisotopicMass: 385.00761762482,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Gdp',
    name: 'Guanosine diphosphate diradical',
    mf: 'C10H13N5O10P2',
    kind: 'RNApp',
    oneLetter: 'G',
    ocl: {
      value:
        'fkhh`INCt\\J\\UENY{NCqmxM|EnNQJJJ[JIQJQHzIRLyxM^uUUUTkUSLuQDSDHfP@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@J_I`JHbGtgD}F@RxPBux`B_]^OTh}R_`CQ`B\\StXA~@C}~@Gx',
    },
    mass: 425.1856780673293,
    monoisotopicMass: 425.01376563368,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Tdp',
    name: 'Thymidine diphosphate diradical',
    mf: 'C10H14N2O11P2',
    kind: 'RNApp',
    oneLetter: 'T',
    ocl: {
      value: 'fmgQh`I^aSbgQSglu`|[^C_@[bdls^rruo}LxDmUUUTruTsTQDqBId@@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPbOs_cbpXbGtSItwPS]@Bux`B_]\\lFBpX_`AMtGx@Owx@_`',
    },
    mass: 400.172914111366,
    monoisotopicMass: 400.00728327219,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Udp',
    name: 'Uridine diphosphate diradical',
    mf: 'C9H12N2O11P2',
    kind: 'RNApp',
    oneLetter: 'U',
    ocl: {
      value: 'fe{Qh`I^aSbgQSehy`|[^E_CkcdRbbfrbTRdqrdYpIZjjjiejfZbHfHQL`@',
      coordinates:
        '!BvuPfpDnDtEK_t_rHtXBH_TwPb@K_cbpXbKtSItwPS]@Bux`Bo]\\lFGx@S]A~@C}~@Gx',
    },
    mass: 386.14629670651925,
    monoisotopicMass: 385.99163320773005,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Atp',
    name: 'Adenosine triphosphate diradical',
    mf: 'C10H14N5O12P3',
    kind: 'RNAppp',
    oneLetter: 'A',
    ocl: {
      value:
        'e`TZCJ@IG@nahJNEHdliemgo`OFspZ|CoByqrIQQSYQJIRIGIRWRL\\^AU]UUUUPKPQMTuABDpaBX`@',
      coordinates:
        '!BvuPfpDnDtEK_t_rHtXBH_TwPbOr_IorHbGtgD}F@RxS|uxc|_]^OTh}R_`CQ`MF@@hcW@A~_`A~@@A~Owx',
    },
    mass: 489.16619066844174,
    monoisotopicMass: 488.98518190347005,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 12 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Ctp',
    name: 'Cytidine triphosphate diradical',
    mf: 'C9H14N3O13P3',
    kind: 'RNAppp',
    oneLetter: 'C',
    ocl: {
      value:
        'fgqZ`I^[BgENbgOQsO\\Gc[pkxK|MnNQJJJ[JIQJSGJPzQg@ejjjjfVffjZbHfHQL`@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@K_cbpXbGtSItwPS]C|ux`B_]\\lFGx@S]@BbM\\B@Gy~@Gx@@Gx_`',
    },
    mass: 465.1414532731331,
    monoisotopicMass: 464.97394851418,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Gtp',
    name: 'Guanosine triphosphate diradical',
    mf: 'C10H14N5O13P3',
    kind: 'RNAppp',
    oneLetter: 'G',
    ocl: {
      value:
        'eh\\ZKJ@IG@nahJNEHdliemco`POFspZ|KoAyqrIQQSYQJIRIGQJQzQccpJkjjjjjeZjYZijbDIaBDq@@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@J_I`JHbGtgD}F@RxPBux`B_]^OTh}R_`CQ`B\\StX@BbM_|@Gy~@Gx@@Gx_`',
    },
    mass: 505.16559559276,
    monoisotopicMass: 504.98009652304,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Ttp',
    name: 'Thymidine triphosphate diradical',
    mf: 'C10H15N2O14P3',
    kind: 'RNAppp',
    oneLetter: 'T',
    ocl: {
      value:
        'eo`TGJ@IOHJNEGHdlnaiekg`OFspZ|Mo@yqrIQQSYQJIRY[ZPzQc`HjjjjjYZjVjZbDIaBDq@@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@K_cbpXbGtSItwPS]@Bux`B_]\\lFBpX_`AMt@JHupH@_gx@_`@@_c}~',
    },
    mass: 480.15283163679663,
    monoisotopicMass: 479.97361416155,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 14 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Utp',
    name: 'Uridine triphosphate diradical',
    mf: 'C9H13N2O14P3',
    kind: 'RNAppp',
    oneLetter: 'U',
    ocl: {
      value:
        'fgPz`I^aSbgQSeoQsO\\Gc[pkxK|MnNQJJJ[JIQJSGJPzQg@ejjjjfVjVjZbHfHQL`@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@K_cbpXbGtSItwPS]C|ux`B_]\\lFGx@S]@BbM\\B@Gy~@Gx@@Gx_`',
    },
    mass: 466.12621423194986,
    monoisotopicMass: 465.95796409709004,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 14 },
      { symbol: 'P', number: 3 },
    ],
  },
  {
    symbol: 'Ade',
    name: 'Adenosine diradical',
    mf: 'C10H11N5O3',
    kind: 'RNA',
    oneLetter: 'A',
    ocl: {
      value: 'fbmia@IV|gLJ\\Axj\\Tef[vyWV\\]zJZjjj`PJ`bIbDSH@',
      coordinates: '!BBOpH_UARccFPEP{PId{RpBN[~i|BEP{iVA@fUARU@QTADBYPId',
    },
    mass: 249.22643809214986,
    monoisotopicMass: 249.08618923539,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Cyt',
    name: 'Cytidine diradical',
    mf: 'C9H11N3O4',
    kind: 'RNA',
    oneLetter: 'C',
    ocl: {
      value: 'fdypQ@INcBgK@|UNJRsM{\\~sg`uUUULmQDSDHfP@',
      coordinates: '!BBOpH_UARccFPEP{PId{RpBN[~iRTBpgDq`@c`BNKB\\@c`',
    },
    mass: 225.20170069684127,
    monoisotopicMass: 225.0749558461,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 4 },
    ],
  },
  {
    symbol: 'Gua',
    name: 'Guanosine diradical',
    mf: 'C10H11N5O4',
    kind: 'RNA',
    oneLetter: 'G',
    ocl: {
      value: 'fj}hQ@IV|gLJ\\JCqTxiKLwmroKNN}EMUUUTkTuDQLPbY@@',
      coordinates: '!BBOpH_UARccFPEP{PId{RpBN[~k|BEP{iVA@fUARU@QTADBYiVA@fP',
    },
    mass: 265.22584301646816,
    monoisotopicMass: 265.08110385496,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 4 },
    ],
  },
  {
    symbol: 'Thy',
    name: 'Thymidine diradical',
    mf: 'C10H12N2O5',
    kind: 'RNA',
    oneLetter: 'T',
    ocl: {
      value: 'fleQQ@INaSed`|UNJRsM{\\zlyxMUUUSMMDQLPbY@@',
      coordinates: '!BBOpH_UARccFPEP{PId{RpBN[~iRTBpgDq`@c`BNKB\\lIpBN',
    },
    mass: 240.21307906050478,
    monoisotopicMass: 240.07462149347,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 5 },
    ],
  },
  {
    symbol: 'Ura',
    name: 'Uridine diradical',
    mf: 'C9H10N2O5',
    kind: 'RNA',
    oneLetter: 'U',
    ocl: {
      value: 'fdyQQ@INaSeh`|UNJRsM{\\~sg`uUUULsQDSDHfP@',
      coordinates: '!BBOpH_UARccFPEP{PId{RpBN[~iRTBpgDq`@c`BNKB\\@c`',
    },
    mass: 226.18646165565798,
    monoisotopicMass: 226.05897142901,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 5 },
    ],
  },
  {
    symbol: 'Dam',
    name: '1,2′-O-dimethyladenosine monophosphate diradical 01A',
    mf: 'C12H16N5O6P',
    kind: 'NucleotideP',
    oneLetter: 'œ',
    ocl: {
      value: 'feghs@E^ct\\J\\udhOEw`eqrIQQQKZIQJQIiLxFK^uUUUUKLtuQDSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@MD@SuH',
    },
    mass: 357.2595904272741,
    monoisotopicMass: 357.08382025367,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dgm',
    name: '1,2′-O-dimethylguanosine monophosphate diradical 01G',
    mf: 'C12H16N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'ε',
    ocl: {
      value: 'fmwis@E^ct\\J\\udlp^KoAKcdRbbbVtRbTbSbSNAbwmUUUURsMSUDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@B\\StPAOT`',
    },
    mass: 373.2589953515923,
    monoisotopicMass: 373.07873487324,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dim',
    name: '1,2′-O-dimethylinosine monophosphate diradical 019A',
    mf: 'C12O7N4H15P',
    kind: 'NucleotideP',
    oneLetter: 'ξ',
    ocl: {
      value: 'fegIs@E^cvENZrTXOEw`eqrIQQQKZIQJQIiLxFK^uUUUUKLtuQDSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@MD@SuH',
    },
    mass: 358.2443513860907,
    monoisotopicMass: 358.06783583658,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 4 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Tia',
    name:
      '2- methylthiomethylenethio-N6-isopentenyl-adenosine monophosphate diradical',
    mf: 'C17H24N5O6PS2',
    kind: 'NucleotideP',
    oneLetter: '£',
    ocl: {
      value:
        'eh\\ZFJ@IG@nahJNEDl`OFspb\\V`cXHrIQQSYQJIRINIYIKQccpJkjjjjjAfBJjfjBDIaBDq@@',
      coordinates:
        '!BpBYTvxBNFY|bEJObGvOS\\@Yt]~DUEJOctu~@Ha}`HzOSTwPTh~H@hc|_`BH_Xa}b@JH@gx@bGvH@h`B_`BH_P',
    },
    mass: 489.50637075565066,
    monoisotopicMass: 489.09056286031,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 17 },
      { symbol: 'H', number: 24 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 2 },
    ],
  },
  {
    symbol: 'Mhc',
    name: '2′‐O‐Methyl-5-hydroxymethylcytidine monophosphate diradical',
    mf: 'C11H16N3O8P',
    kind: 'NucleotideP',
    oneLetter: '¡',
    ocl: {
      value: 'fikpK@EA{BgM^rTXOEw`eqrIQQQKZIQJSJigHujjjjifYjkBHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@HoTuOSU@HC~NKA`HoQLgSUAMT@a}oS_|BBpXKAaMT@CQ',
    },
    mass: 349.2342579562838,
    monoisotopicMass: 349.06750148395,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Odg',
    name: 'N2,2′-O-dimethylguanosine monophosphate diradical 02G',
    mf: 'C12H16N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'γ',
    ocl: {
      value: 'fmwis@E^ct\\J\\udlp^KoAKcdRbbbVtRbTbSbsNAbwmUUUURsMSUDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@B\\StPAOT`',
    },
    mass: 373.2589953515923,
    monoisotopicMass: 373.07873487324,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ntg',
    name: 'N2,N2,2′-O-trimethylguanosine monophosphate diradical 022G',
    mf: 'C13H18N5O7P',
    kind: 'NucleotideP',
    oneLetter: '|',
    ocl: {
      value: 'fcois@E^ct\\J\\udlp^KoAKcdRbbbVtRbTbSbTYpLVcjjjjjVYjZjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuHgD}D@tPBNOt}R',
    },
    mass: 387.2856127564392,
    monoisotopicMass: 387.0943849377,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Otg',
    name: 'N2,7,2′-O-trimethylguanosine monophosphate diradical 027G',
    mf: 'C13H20N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'æ',
    ocl: {
      value:
        'fcoisBE^bN\\J\\udjp^KoAKcFU}dRbbbVtRbTbRlQYpLVcjjjjjVYjjjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKFPMD@IqOQ@D}R',
    },
    mass: 389.30149426455074,
    monoisotopicMass: 389.11003500216,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Rya',
    name: '2′-O-ribosyladenosine monophosphate diradical 00A',
    mf: 'C15H20N5O9P',
    kind: 'NucleotideP',
    oneLetter: '^',
    ocl: {
      value:
        'e`\\ZIL@DaegobFAIO@hlm`OGSp\\\\\\bbbfrRbdTT\\rbRQUCDQTrusuUUUUMUU@pET@@@',
      coordinates:
        '!BIlAKaMARw}DBbMF@bGuMtHc|KAbH_ZU`@GzH_WwW@h`XKFjKB_jXB\\SiVA`zmG_Irp_hQKctvOSR\\lIrp',
    },
    mass: 445.3217759066577,
    monoisotopicMass: 445.09986424130005,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ryg',
    name: '2′-O-ribosylguanosine monophosphate diradical 00G',
    mf: 'C15H20N5O10P',
    kind: 'NucleotideP',
    oneLetter: 'ℑ',
    ocl: {
      value:
        'ehRZEL@DaegobFAIO@hlm`POGSp\\\\\\bbbfrRbdTT\\rbRQbhXbJfVn^jjjjijjjVZfj@@@',
      coordinates:
        '!BIlAKaMARw}DBbMF@bGuMtH`BKAbH_ZU`@GzH_WwW@h`XKFjKB_jXB\\SiVA`zmG_Irp_hQKctvOSR\\lt]|gK@',
    },
    mass: 461.321180830976,
    monoisotopicMass: 461.09477886087,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Tmu',
    name: '2-thio-2′-O-methyluridine monophosphate diradical 02U',
    mf: 'C10H13N2O7PS',
    kind: 'NucleotideP',
    oneLetter: '∏',
    ocl: {
      value: 'fncQp`EAaSfleZCq]x^BDnNQJJJI[QJIRYlyFmUUUULsSQDSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXSU@',
    },
    mass: 336.25837906774416,
    monoisotopicMass: 336.01810893766003,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Dmut',
    name: '3,2′-O-dimethyluridine monophosphate diradical 03U',
    mf: 'C11H15N2O8P',
    kind: 'NucleotideP',
    oneLetter: 'σ',
    ocl: {
      value: 'fasPK@EAaSfoYKtGb{pRxyDhhhemDheIhv\\cVjjjjfYjZHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXOxyMT@',
    },
    mass: 334.2196139907822,
    monoisotopicMass: 334.05660244729,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Amc',
    name: 'N4-acetyl-2′-O-methylcytidine monophosphate diradical 042C',
    mf: 'C12H16N3O8P',
    kind: 'NucleotideP',
    oneLetter: 'ℵ',
    ocl: {
      value: 'fe{pK@EA[BgM^rTXOEw`eqrIQQQKZIQJSMJLyFmUUUULsMMQDSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXSU@caLgSU@',
    },
    mass: 361.244993853019,
    monoisotopicMass: 361.06750148395,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Tmc',
    name: 'N4,N4,2′-O-trimethylcytidine monophosphate diradical 044C',
    mf: 'C12H18N3O7P',
    kind: 'NucleotideP',
    oneLetter: 'β',
    ocl: {
      value: 'fikqs@EA[BgM^rTGb{pRxyDhhhemDheIfhsdZuUUUTsLuTQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXSU@cbpX',
    },
    mass: 347.2614704368123,
    monoisotopicMass: 347.08823692884005,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dcy',
    name: 'N4,2′-O-dimethylcytidine monophosphate diradical 04C',
    mf: 'C11H16N3O7P',
    kind: 'NucleotideP',
    oneLetter: 'λ',
    ocl: {
      value: 'fasqs@EA[BgM^rTGb{pRxyDhhhemDheIff\\cVjjjjfYfjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXSU@lF@',
    },
    mass: 333.23485303196554,
    monoisotopicMass: 333.07258686438,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Muo',
    name:
      '2′-O-methyluridine 5-oxyacetic acid methyl ester monophosphate diradical 0503U',
    mf: 'C13H17N2O11P',
    kind: 'NucleotideP',
    oneLetter: 'Ͽ',
    ocl: {
      value: 'fkoQk@EAaSfoYJwj}`|W^BWGHeEEDmheDiLjlif\\cVjjjjfYjZZhbIbDSH@',
      coordinates:
        '!BKAb@tURD@m\\YpMAMpBYMcvjbOplIwx@bGuMc}\\Bb@JH@dvOcuKPSXa}bGvHH`BbGu~Oxc|bGt',
    },
    mass: 408.25518206531905,
    monoisotopicMass: 408.05699637046,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 17 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Xmu',
    name:
      '5-carboxymethylaminomethyl-2′-O-methyluridine monophosphate diradical 051U',
    mf: 'C13H18N3O10P',
    kind: 'NucleotideP',
    oneLetter: ')',
    ocl: {
      value: 'fkopk@EAGBgM^rWns`|W^BWGHeEEDmheDiLjleF\\cVjjjjfYjZfhbIbDSH@',
      coordinates:
        '!BKAb@tURD@m\\YpMAMpBYMcvjb@HlIwx@bGuMc}\\Bb@JH@dvOcuKPSXa}bGvH@h`BbGvH@gx@bKt',
    },
    mass: 407.2704211065024,
    monoisotopicMass: 407.07298078755,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mmu',
    name:
      '5-methoxycarbonylmethyl-2′-O-methyluridine monophosphate diradical 0521U',
    mf: 'C13H17N2O10P',
    kind: 'NucleotideP',
    oneLetter: '∩',
    ocl: {
      value: 'fcwPk@EAaSfoYKvZp^KoAKcdRbbbVtRbTfUVfYrMZjjjjYfifjHbXaDr@@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lI}mK_`B@cm\\Bb@HlI}]}_`A~@BpgIqLXKH`Bb@I~@Ha}_c~HHa}',
    },
    mass: 392.2557771410008,
    monoisotopicMass: 392.06208175089,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 17 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Cue',
    name:
      '5-(carboxyhydroxymethyl)-2′-O-methyluridine methyl ester monophosphate diradical 0522U',
    mf: 'C13H17N2O11P',
    kind: 'NucleotideP',
    oneLetter: '∩',
    ocl: {
      value: 'fkoQk@EAaSfoYKtZ}`|W^BWGHeEEDmheDiLjhYf\\cVjjjjfYjZZhbIbDSH@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lI}mK_`B@cm\\Bb@HlI}]}_`A~@BpgIqLXKH`Bb@I~@Gx@bGu~Oxc|bGt',
    },
    mass: 408.25518206531905,
    monoisotopicMass: 408.05699637046,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 17 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Cyu',
    name: '5-carbamoylmethyl-2′-O-methyluridine monophosphate diradical 053U',
    mf: 'C12H16N3O9P',
    kind: 'NucleotideP',
    oneLetter: '~',
    ocl: {
      value: 'fmgqK@EAWBgM^rWlp^KoAKcdRbbbVtRbTfUVcNQkUUUUSLuLuDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXKAaMTDuPOxxlF@',
    },
    mass: 377.24439877733727,
    monoisotopicMass: 377.06241610352,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ipu',
    name:
      '5-(isopentenylaminomethyl)-2′-O-methyluridine monophosphate diradical 0583U',
    mf: 'C16H24N3O8P',
    kind: 'NucleotideP',
    oneLetter: '¼',
    ocl: {
      value: 'fgpK@EAGBgM^rWhOEw`eqrIQQQKZIQJSJkIJLyFmUUUULsTuMTQDqBId@@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lI}mK_`B@cm\\Bb@HlI}]}_`A~@BpgIqLXKH`Bb@I~@Ha}b@JH_Xc|_`BH_P',
    },
    mass: 417.35146347240624,
    monoisotopicMass: 417.13010174179004,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 16 },
      { symbol: 'H', number: 24 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mcy',
    name:
      '5,2′-O-dimethylcytidine monophosphate diradical monophosphate diradical 05C',
    mf: 'C11H16N3O7P',
    kind: 'NucleotideP',
    oneLetter: 'τ',
    ocl: {
      value: 'fasqs@EA{BgM^rTGb{pRxyDhhhemDheIeV\\cVjjjjfYfjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXKAaMT@',
    },
    mass: 333.23485303196554,
    monoisotopicMass: 333.07258686438,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dmuf',
    name: '5,2′-O-dimethyluridine monophosphate diradical 05U',
    mf: 'C11H15N2O8P',
    kind: 'NucleotideP',
    oneLetter: '\\',
    ocl: {
      value: 'fasPK@EAaSfoYKtGb{pRxyDhhhemDheIeV\\cVjjjjfYjZHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXKAaMT@',
    },
    mass: 334.2196139907822,
    monoisotopicMass: 334.05660244729,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Tma',
    name: 'N6,N6,2′-O-trimethyladenosine monophosphate diradical 066A',
    mf: 'C13H18N5O6P',
    kind: 'NucleotideP',
    oneLetter: 'η',
    ocl: {
      value: 'fmwhs@E^ct\\J\\udhOEw`eqrIQQQKZIQJQIkQg@q[vjjjj`Y`JjBHfHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@MD@SuHXK@',
    },
    mass: 371.2862078321209,
    monoisotopicMass: 371.09947031813005,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Nda',
    name: 'N6,2′-O-dimethyladenosine monophosphate diradical 06A',
    mf: 'C12H16N5O6P',
    kind: 'NucleotideP',
    oneLetter: 'χ',
    ocl: {
      value: 'feghs@E^ct\\J\\udhOEw`eqrIQQQKZIQJQIkLxFK^uUUUTCLAUADSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@MD@FBp',
    },
    mass: 357.2595904272741,
    monoisotopicMass: 357.08382025367,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Fmc',
    name: '5-formyl-2′-O-methylcytidine monophosphate diradical 071C',
    mf: 'C10H12N3O8P',
    kind: 'NucleotideP',
    oneLetter: '°',
    ocl: {
      value: 'faspK@I^[BgENSghOFwaEqrIQQSYQJIRYULxDmUUUTsLttQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tP',
    },
    mass: 333.1917590433254,
    monoisotopicMass: 333.03620135502996,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Omi',
    name: '2′-O-methylinosine monophosphate diradical 09A',
    mf: 'C11H13N4O7P',
    kind: 'NucleotideP',
    oneLetter: '≤',
    ocl: {
      value: 'fi{Is@E^cvENZrTXOEw`eqrIQQQKZIQJQIig@q[vjjjjiYffhbIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@MD@',
    },
    mass: 344.21773398124395,
    monoisotopicMass: 344.05218577211997,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 4 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Opu',
    name: '2′-O-methylpseudouridine monophosphate diradical 09U',
    mf: 'C10H13N2O8P',
    kind: 'NucleotideP',
    oneLetter: 'Z',
    ocl: {
      value: 'fncPK@@qaSfoYJtGb{pRxyDhhhemDheIfsdZuUUULuMMDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXSU@',
    },
    mass: 320.1929965859354,
    monoisotopicMass: 320.04095238282997,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Oma',
    name: '2′-O-methyladenosine monophosphate diradical 0A',
    mf: 'C11H14N5O6P',
    kind: 'NucleotideP',
    oneLetter: ':',
    ocl: {
      value: 'fi{hs@E^ct\\J\\udhOEw`eqrIQQQKZIQJQIig@q[vjjjj`Y`J`bIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@MD@',
    },
    mass: 343.2329730224273,
    monoisotopicMass: 343.06817018921,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Omc',
    name: '2′-O-methylcytidine monophosphate diradical 0C',
    mf: 'C10H14N3O7P',
    kind: 'NucleotideP',
    oneLetter: 'B',
    ocl: {
      value: 'fncqs@EA[BgM^rTGb{pRxyDhhhemDheIfsdZuUUUTsLuDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXSU@',
    },
    mass: 319.2082356271187,
    monoisotopicMass: 319.05693679992004,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Omg',
    name: '2′-O-methylguanosine monophosphate diradical 0G',
    mf: 'C11H14N5O7P',
    kind: 'NucleotideP',
    oneLetter: '#',
    ocl: {
      value: 'fegis@E^ct\\J\\udlp^KoAKcdRbbbVtRbTbSbYpLV}jjjjjVYjZbHfHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@HoTuOSU@HEF@`H_R\\StPAKA@a}_S_|BD}RSuKQ@B\\StP@',
    },
    mass: 359.23237794674554,
    monoisotopicMass: 359.06308480878,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Omu',
    name: '2′-O-methyluridinemonophosphate diradical 0U',
    mf: 'C10H13N2O8P',
    kind: 'NucleotideP',
    oneLetter: 'J',
    ocl: {
      value: 'fncPK@EAaSfoYJtGb{pRxyDhhhemDheIfsdZuUUUTsMMDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuOSU@HC~NKA`H_QLgSUAMT@a}_S_|BBpXSU@',
    },
    mass: 320.1929965859354,
    monoisotopicMass: 320.04095238282997,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Cdg',
    name: '7-cyano-7-deazaguanosine monophosphate diradical 100G',
    mf: 'C12H12N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'φ',
    ocl: {
      value: 'fmwis@INzM\\J\\TgLp^MoBKcdRbbfrbTRdRUbSN^CWmUUUUKLuSuDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RqdCQ@B\\StPCFP@',
    },
    mass: 369.22723233536925,
    monoisotopicMass: 369.04743474432,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Azg',
    name: '7-aminomethyl-7-deazaguanosine monophosphate diradical 101G',
    mf: 'C12H16N5O7P',
    kind: 'NucleotideP',
    oneLetter: '∉',
    ocl: {
      value: 'fmwis@INzM\\J\\TgLp^MoBKcdRbbfrbTRdRUbSN^CWmUUUUKLuSUDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RqdCQ@B\\StPA`z`',
    },
    mass: 373.2589953515923,
    monoisotopicMass: 373.07873487324,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Eqo',
    name: 'epoxyqueuosine monophosphate diradical 102G',
    mf: 'C17H22N5O10P',
    kind: 'NucleotideP',
    oneLetter: 'ς',
    ocl: {
      value:
        'el^ZEL@IGNaehJNEDlig`TPOFspb\\\\bTTTvTRbTbRlRjbbfXx|Bjz~aAajjjjiYfjZjjjjHPfDHSD@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RqdCQ@B\\StP@{ULY@TEIKA@a}tPA}BOpHAEP',
    },
    mass: 487.3585341325581,
    monoisotopicMass: 487.11042892533,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 17 },
      { symbol: 'H', number: 22 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Aes',
    name: 'archaeosine monophosphate diradical 103G',
    mf: 'C12H15N6O7P',
    kind: 'NucleotideP',
    oneLetter: '(',
    ocl: {
      value: 'fcoYs@INzM^xTxiNY`|[^DWGHeEEMeDheHdkDhsg`u{UUUURsMTmTQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RqdCQ@B\\StP@{UFCj',
    },
    mass: 386.2577578089824,
    monoisotopicMass: 386.07398384544,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Goq',
    name: 'galactosyl-queuosine monophosphate diradical 104G',
    mf: 'C23H32N5O14P',
    kind: 'NucleotideP',
    oneLetter: '9',
    ocl: {
      value:
        'ekXzGL@IGNaehJNEDliod\\VU]SPOFspb\\\\bTTTvTRbTbRlRjbTrTrbfRXx|Bjz^AyEjjjjiYfjZijjjjjjbDIaBDq@@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@J_IorHbGtgD}F@RxRH_WwW@hbOTh}RIlCQ`B\\StXC[UB[@RxSPT`JHbGwQ`H`BaEQ~@Ha}bOq~Ox`BbGu~@Ha}bOrH@`',
    },
    mass: 633.4999767508004,
    monoisotopicMass: 633.16833772591,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 23 },
      { symbol: 'H', number: 32 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 14 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Gaq',
    name: 'glutamyl-queuosine monophosphate diradical105G',
    mf: 'C22H29N6O12P',
    kind: 'NucleotideP',
    oneLetter: '⊄',
    ocl: {
      value:
        'emWVCL@IGNaejXJNEDlioh\\YUPOFspb\\\\bTTTvTRbTbRlRjbTJTtrTXx|Bjz^AjjjjiYfjZijfjfjbDIaBDq@@',
      coordinates:
        '!BTmB@c`JHUMmMtL@YtEHYgxQTaDoQ`L@YFY|gKMARH`Ygy|fpAfN`Hz@`H{PTb\\ltEIRtHBNHaTv|@YFYPTha}b@I~@Ha}_c~H@ha}bOq~@Ha}',
    },
    mass: 600.473311954707,
    monoisotopicMass: 600.15810739451,
    unsaturation: 22,
    elements: [
      { symbol: 'C', number: 22 },
      { symbol: 'H', number: 29 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 12 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Moq',
    name: 'mannosyl-queuosine monophosphate diradical 106G',
    mf: 'C23H32N5O14P',
    kind: 'NucleotideP',
    oneLetter: '8',
    ocl: {
      value:
        'ekXzGL@IGNaehJNEDliod\\VU]SPOFspb\\\\bTTTvTRbTbRlRjbTrTrbfRXx|Bjz^AyEjjjjiYfjZijjjjjjbDIaBDq@@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@J_IorHbGtgD}F@RxRH_WwW@hbOTh}RIlCQ`B\\StXC[UB[@RxSPT`JHbGwQ`H`BaEQ~@Ha}bOq~Ox`BbGu~@Ha}bOrH@`',
    },
    mass: 633.4999767508004,
    monoisotopicMass: 633.16833772591,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 23 },
      { symbol: 'H', number: 32 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 14 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Qus',
    name: 'queuosine monophosphate diradical 10G',
    mf: 'C17H22N5O9P',
    kind: 'NucleotideP',
    oneLetter: 'Q',
    ocl: {
      value:
        'edZZIL@IGNaehJNEDliohPOFspb\\\\bTTTvTRbTbRlRjbTKGG`UWSpMUUUUKLuSUMUTPaLHPfH@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPHoWtw@aOTd}RqdCQ@B\\StP@{ULY@RpQPTopHBGwQ@@QT',
    },
    mass: 471.35912920823984,
    monoisotopicMass: 471.11551430576,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 17 },
      { symbol: 'H', number: 22 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Cpo',
    name:
      '1-methyl-3-(3-amino-3-carboxypropyl)pseudouridine monophosphate diradical 1309U',
    mf: 'C14H20N3O10P',
    kind: 'NucleotideP',
    oneLetter: 'α',
    ocl: {
      value: 'fgpk@OAWBgENSgi{`|[^DWGHeEEMeDheIhjbihs`RuUUTsTuSUMQDSDHfP@',
      coordinates:
        '!BTh|SI~ioOwy`iR\\SiV|SFGxw}FH_]]}DqbH@gx_c|SFA`lIqOW_Xa}uwu~Ox`BbGu~Ox`B_`BH_P',
    },
    mass: 421.2970385113492,
    monoisotopicMass: 421.08863085201,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 14 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mls',
    name: '1-methylinosine monophosphate diradical 19A',
    mf: 'C11H13N4O7P',
    kind: 'NucleotideP',
    oneLetter: 'O',
    ocl: {
      value: 'fi{Is@INBvENJSghOFwaEqrIQQSYQJIRIMIgOAjvjjjjefZZhbIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtPCQ@D}R',
    },
    mass: 344.21773398124395,
    monoisotopicMass: 344.05218577211997,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 4 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mpu',
    name: '1-methylpseudouridine monophosphate diradical 19U',
    mf: 'C10H13N2O8P',
    kind: 'NucleotideP',
    oneLetter: ']',
    ocl: {
      value: 'fncPK@OAaSbgIrtGc[pbxyDhhilheDiLjs`RuUUTsTuMDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@',
    },
    mass: 320.1929965859354,
    monoisotopicMass: 320.04095238282997,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mad',
    name: '1-methyladenosine monophosphate diradical 1A',
    mf: 'C11H14N5O6P',
    kind: 'NucleotideP',
    oneLetter: '"',
    ocl: {
      value: 'fi{hs@INBwlJ\\TgHOFwaEqrIQQSYQJIRIMIgOAjvjjjjefZZhbIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtPCQ@D}R',
    },
    mass: 343.2329730224273,
    monoisotopicMass: 343.06817018921,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mgs',
    name: '1-methylguanosine monophosphate diradical 1G',
    mf: 'C11H14N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'K',
    ocl: {
      value: 'fegis@INBwlJ\\TgHp^MoBKcdRbbfrbTRdR\\RYspZmjjjjiYfijbHfHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtP@gD}D@SuH',
    },
    mass: 359.23237794674554,
    monoisotopicMass: 359.06308480878,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Msu',
    name: '5-aminomethyl-2-selenouridine monophosphate diradical 20510U',
    mf: 'C10H14N3O7PSe',
    kind: 'NucleotideP',
    oneLetter: 'π',
    ocl: {
      value: 'fasqp`I^{BgEIrtGc[p\\bQ\\\\bTTTvTRbTfUSNAKUUUULsTuDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tP',
    },
    mass: 398.1676241841323,
    monoisotopicMass: 398.97345859992004,
    unsaturation: null,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'Se', number: 1 },
    ],
  },
  {
    symbol: 'Mse',
    name: '5-methylaminomethyl-2-selenouridine monophosphate diradical 20511U',
    mf: 'C11H16N3O7PSe',
    kind: 'NucleotideP',
    oneLetter: '≅',
    ocl: {
      value: 'fikqp`I^{BgEIrtGc[p\\bQ\\\\bTTTvTRbTfUVYpIZjjjifZfjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSUAMTBpX',
    },
    mass: 412.19424158897914,
    monoisotopicMass: 412.98910866438,
    unsaturation: null,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'Se', number: 1 },
    ],
  },
  {
    symbol: 'Cse',
    name:
      '5-carboxymethylaminomethyl-2-selenouridine monophosphate diradical 2051U',
    mf: 'C12H16N3O9PSe',
    kind: 'NucleotideP',
    oneLetter: '⊥',
    ocl: {
      value: 'fcwqH`I^{BgEIru^p^MoArIEqrIQQSYQJIRYUYJLxDmUUUTsMSTuDQLPbY@@',
      coordinates:
        '!BKAb@tURDM\\YpMAMpBYMcx`BKB]~@Ha}SXW@h`Bb@IMcx}RtDvH_Xa}b@JH@ha}b@I~@Ha}',
    },
    mass: 456.20378733435086,
    monoisotopicMass: 456.97893790352,
    unsaturation: null,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
      { symbol: 'Se', number: 1 },
    ],
  },
  {
    symbol: 'Agm',
    name: 'agmatidine monophosphate diradical 20C',
    mf: 'C14H26N7O6P',
    kind: 'NucleotideP',
    oneLetter: '¿',
    ocl: {
      value: 'fgxs@I^BuY{piqR\\`|[^DWGHeEEMeDeEHmUddhsgbuUUUSTuUUMIDSDHfP@',
      coordinates:
        '!BDqc_tTnD_]\\fpH}MgrYRc}_|Dr_W_Wx@ThWM_|bOqRc}ARctu~@Gx@urH@gx@b@I~@H`BbGu~@@',
    },
    mass: 419.373876184194,
    monoisotopicMass: 419.16821858483,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 14 },
      { symbol: 'H', number: 26 },
      { symbol: 'N', number: 7 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Sou',
    name: '2-selenouridine monophosphate diradical 20U',
    mf: 'C9H11N2O7PSe',
    kind: 'NucleotideP',
    oneLetter: 'ω',
    ocl: {
      value: 'ff}Qp`I^aSbdyjCqmxNQHnNQJJJ[JIQJSMg@ejjjjfYihbIbDSH@',
      coordinates: '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuP',
    },
    mass: 369.1263628137839,
    monoisotopicMass: 369.9469094988,
    unsaturation: null,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'Se', number: 1 },
    ],
  },
  {
    symbol: 'Agu',
    name: '5-aminomethyl-2-geranylthiouridine monophosphate diradical 21510U',
    mf: 'C20H30N3O7PS',
    kind: 'NucleotideP',
    oneLetter: 'Δ',
    ocl: {
      value:
        'ed\\\\NB@IOIhJNEDla`OFsp\\BHgGHeEEMeDheHdjdcEdhqpEUUUUURsUSMTuQBDpaBXdDt@',
      coordinates:
        '!BDr__cdo[_X`fgx}RgqeRtM]}Dqa~O}\\BTmBH_]]}uwuRtMAMcuI~O}\\BupJH_]]}_`A~Oxa}uwu~Oxa}_cW_Xa}',
    },
    mass: 487.5074340654907,
    monoisotopicMass: 487.15420849000003,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 20 },
      { symbol: 'H', number: 30 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mgu',
    name:
      '5-methylaminomethyl-2-geranylthiouridine monophosphate diradical 21511U',
    mf: 'C21H32N3O7PS',
    kind: 'NucleotideP',
    oneLetter: 'h',
    ocl: {
      value:
        'elR\\NB@IOIhJNEDla`OFsp\\BHgGHeEEMeDheHdjdlileFN@jjjjjjVZjYjijbDIaBDqHIh',
      coordinates:
        '!BTv^cbn{__@fw|}RwqeRdK]}Tva~_{_|TiCp_[]}mwuRdIAMsuI~_{]|mwsp_[]}mwu~_{_||Gvw_Wy|Gu~_{]}|Gt',
    },
    mass: 501.5340514703375,
    monoisotopicMass: 501.16985855446006,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 21 },
      { symbol: 'H', number: 32 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Cgu',
    name:
      '5-carboxymethylaminomethyl-2-geranylthiouridine monophosphate diradical 2151U',
    mf: 'C22H32N3O9PS',
    kind: 'NucleotideP',
    oneLetter: 'f',
    ocl: {
      value:
        'ef^\\IB@IOIhJNEDla`XPOFsp\\BHgGHeEEMeDheHdjdlhehbhqpEUUUUURsUSMUMMTPaLHPfIAM@',
      coordinates:
        '!BTv^cbn{_@fw|}RwqeRdK]}Tva~_{]|TiCp[_}muRdIAMsuI~_{]|mwsp_[]}mwu~_{]||Gvw_[_}_g}~_{]||Ou~_{]}|Gt',
    },
    mass: 545.5435972157093,
    monoisotopicMass: 545.1596877935999,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 22 },
      { symbol: 'H', number: 32 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mha',
    name:
      '2-methylthio-N6-(cis-hydroxyisopentenyl) adenosine monophosphate diradical 2160A',
    mf: 'C16H22N5O7PS',
    kind: 'NucleotideP',
    oneLetter: '≠',
    ocl: {
      value:
        'e`TZNB@IG@nahJNEDlo`OFspb\\V`cHeEEMeDheHdxeleDqqxEUuUUUU@sAETuTDHSBDIbP[P',
      coordinates:
        '!BzfC@IeKPaDn}bHCQb@KQwuRDFALYpHCQt]WHc|TmCQw}~N`ME~@Gx@upJH@h`B_`BH_X`BbGvHGxbGt',
    },
    mass: 459.41437086899504,
    monoisotopicMass: 459.09775624102,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 16 },
      { symbol: 'H', number: 22 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mpa',
    name: '2-methylthio-N6-isopentenyladenosine monophosphate diradical 2161A',
    mf: 'C16H22N5O6PS',
    kind: 'NucleotideP',
    oneLetter: '*',
    ocl: {
      value:
        'eohZFB@IG@nahJNEDl`OFspb\\V`cHeEEMeDheHdxeleFNO@jnjjjjhFXHjfjBDIaBDq@@',
      coordinates:
        '!BpBYTvxBNFY|bEJObGvOS\\@Yt]~DUEJOctu~@Ha}`HzOSTwPTh~H@h`B_`BH_Xa}bOrH@ha}b@I~@Ha}',
    },
    mass: 443.4149659446768,
    monoisotopicMass: 443.10284162145,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 16 },
      { symbol: 'H', number: 22 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mca',
    name:
      '2-methylthio-N6-threonylcarbamoyladenosine monophosphate diradical 2162A',
    mf: 'C16H21N6O10PS',
    kind: 'NucleotideP',
    oneLetter: '[',
    ocl: {
      value:
        'ebVVEB@IG@nachJNEDlm`XTPOFspb\\V`cHeEEMeDheHdxemLhhhqqxEUuUUUU@sAESUMUABDpaBX`@',
      coordinates:
        '!BzfC@IeKPaDn}bHCQb@KQwuRDFALYpHCQt]W@h`BTmCQw}~N`ME~@Gx@upJH@h`B_`BH_Wxb@JH_WxbOrHo]^}_`BH_P',
    },
    mass: 520.4113480993399,
    monoisotopicMass: 520.07774907193,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 16 },
      { symbol: 'H', number: 21 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mva',
    name:
      '2-methylthio-N6-hydroxynorvalylcarbamoyladenosine monophosphate diradical 2163A',
    mf: 'C17H23N6O10PS',
    kind: 'NucleotideP',
    oneLetter: '≈',
    ocl: {
      value:
        'ej^VEB@IG@nachJNEDlm`XTPOFspb\\V`cHeEEMeDheHdxemLhhiVNO@jnjjjjhFXHjZijjBDIaBDq@@',
      coordinates:
        '!BpBYTvxBNFY|BbEJObGvOS\\@Yt]~DUEJOctu~@Ha}`HzOSTwPTh~H@h`B_`BH_Xa}bOrH@gx@bGvHGx@bGwW@h`B_c~H@ha}',
    },
    mass: 534.4379655041866,
    monoisotopicMass: 534.09339913639,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 17 },
      { symbol: 'H', number: 23 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mya',
    name:
      '2-methylthio cyclic N6-threonylcarbamoyladenosine monophosphate diradical 2164A',
    mf: 'C17H20N5O9PS',
    kind: 'NucleotideP',
    oneLetter: 'ÿ',
    ocl: {
      value:
        'elVZIB@IG@nkhJNEDlcghPOFspb\\V`cHeEEMeDheHdxeihiUFNO@jnkojjjjhFXHjfZjbHPfDHSD@@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@J_IorHbGtgD}F@RxRH_WwW@hbOTh}RIqOQ`MF@cuKW@hQTcttfpL@YS]@BbGvH@Gx',
    },
    mass: 501.4080351062552,
    monoisotopicMass: 501.07193541570007,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 17 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Hta',
    name: 'hydroxy-N6-threonylcarbamoyladenosine monophosphate diradical 2165A',
    mf: 'C15H19N6O11P',
    kind: 'NucleotideP',
    oneLetter: '«',
    ocl: {
      value:
        'elZVML@IG@fnehJNEDligo`TPOFspb\\\\bTTTvTRbTbSVTrbbeXx|BjZjjjj`Y`JZijjBDIaBDq@@',
      coordinates:
        '!BpBYTvxBNFY|bEJObGvOS\\@Yt]~DUEJOctu~@Ha}`HzOSTwPTh~HH`BbGvH_Xc|_`BH_Xc|_`BH_]_|bOq~Oxc|bGt',
    },
    mass: 490.31934821268436,
    monoisotopicMass: 490.08494245264,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 19 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Lyd',
    name: '2-lysidine monophosphate diradical 21C',
    mf: 'C15H24N5O8P',
    kind: 'NucleotideP',
    oneLetter: '}',
    ocl: {
      value:
        'eo`ZAL@IGOFmhJNEDlkg`OFspb\\\\bTTTvTRbTbSVRTtXxBJjjjjfYjZjfhaBXPaLP@',
      coordinates:
        '!BTh|SI~ioOwy`iR\\SiV|SFGxw}FH_]]}Dqa~Oxc|_c|SFA`lIqOW_Xa}_c~HHa}bOrH_WxbOq~@Ha}',
    },
    mass: 433.3541339985626,
    monoisotopicMass: 433.13624975064994,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 24 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Gtu',
    name: '2-geranylthiouridine monophosphate diradical 21U',
    mf: 'C19H27N2O7PS',
    kind: 'NucleotideP',
    oneLetter: 'Γ',
    ocl: {
      value:
        'e`XTNB@IOHJNEDln`OFsp\\BHgGHeEEMeDheHdtmEdhqpEUUUUURsUKUMTPaLHPfIAu@',
      coordinates:
        '!BTv^cbn{__@fw|}RwqeRdK]}Tva~_{_|TiCp_[]}mwuRdIAMsuI~_{]||Gvw_Wy|Gvw_Wy|Gu~_{]}|Gt',
    },
    mass: 458.46617269514235,
    monoisotopicMass: 458.12765938888003,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 19 },
      { symbol: 'H', number: 27 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Tyg',
    name:
      'N2,N2,7-trimethylguanosine cap monophosphate diradical (cap TMG) 2279553N',
    mf: 'C13H20N5O10P2',
    kind: 'NucleotideP',
    oneLetter: '¶',
    ocl: {
      value:
        'e`TZEBHIG@aihJNEHdleck`OFspz|MgDJTef[vVVe_gifNO@jijjjjjUijifjhaBXPaLP@',
      coordinates:
        '!BvuPfpDnDtEK_t_rHtXBH_TwPbOr_I`JHbGtgD}F@RxS|uxc|_]^OTh}RIlA~@B\\StXCQ`Gx@Owx@_h{_cuH',
    },
    mass: 468.2734710359255,
    monoisotopicMass: 468.06854085929,
    unsaturation: 13,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Tmg',
    name: 'N2,N2,7-trimethylguanosine monophosphate diradical 227G',
    mf: 'C13H20N5O7P',
    kind: 'NucleotideP',
    oneLetter: '∠',
    ocl: {
      value:
        'fcoisBINCt\\J\\TgLp^MoBKbFY}dRbbfrbTRdRUbtYspZcjjjjiYfjjjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}Rqd@gD}D@tPBNOt}R',
    },
    mass: 389.30149426455074,
    monoisotopicMass: 389.11003500216,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dgu',
    name: 'N2,N2-dimethylguanosine monophosphate diradical 22G',
    mf: 'C12H16N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'R',
    ocl: {
      value: 'fmwis@INBwlJ\\TgHp^MoBKcdRbbfrbTRdR\\RcN^CWmUUUUKLuMUDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RIqOQ@MD@cc}OT`',
    },
    mass: 373.2589953515923,
    monoisotopicMass: 373.07873487324,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Atu',
    name: '5-aminomethyl-2-thiouridine monophosphate diradical 2510U',
    mf: 'C10H14N3O7PS',
    kind: 'NucleotideP',
    oneLetter: '∫',
    ocl: {
      value: 'fasqp`I^{BgEIrtGc[p\\DQ\\\\bTTTvTRbTfUSNAKUUUULsTuDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tP',
    },
    mass: 351.27302303324575,
    monoisotopicMass: 351.02900797432005,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mou',
    name: '5-methylaminomethyl-2-thiouridine monophosphate diradical 2511U',
    mf: 'C11H16N3O7PS',
    kind: 'NucleotideP',
    oneLetter: 'S',
    ocl: {
      value: 'fikqp`I^{BgEIrtGc[p\\DQ\\\\bTTTvTRbTfUVYpIZjjjifZfjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSUAMTBpX',
    },
    mass: 365.2996404380926,
    monoisotopicMass: 365.04465803878,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Ctu',
    name:
      '5-carboxymethylaminomethyl-2-thiouridine monophosphate diradical 251U',
    mf: 'C12H16N3O9PS',
    kind: 'NucleotideP',
    oneLetter: '$',
    ocl: {
      value: 'fcwqH`I^{BgEIru^p^MoApQEqrIQQSYQJIRYUYJLxDmUUUTsMSTuDQLPbY@@',
      coordinates:
        '!BKAb@tURDM\\YpMAMpBYMcx`BKB]~@Ha}SXW@h`Bb@IMcx}RtDvH_Xa}b@JH@ha}b@I~@Ha}',
    },
    mass: 409.3091861834643,
    monoisotopicMass: 409.03448727792,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Myu',
    name: '5-methoxycarbonylmethyl-2-thiouridine monophosphate diradical 2521U',
    mf: 'C12H15N2O9PS',
    kind: 'NucleotideP',
    oneLetter: '3',
    ocl: {
      value: 'fmgQH`I^aSbdyZNXOFw`xHbxyDhhilheDiLjmLs`RuUUUSLuLuQDSDHfP@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lIwx@`H{WHc|KB_W_Wx@_`@lIr\\SFBrH@h`B_`BH_WxbOrH_P',
    },
    mass: 394.2945422179627,
    monoisotopicMass: 394.02358824126003,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Cou',
    name: '5-carbamoylmethyl-2-thiouridine monophosphate diradical 253U',
    mf: 'C11H14N3O8PS',
    kind: 'NucleotideP',
    oneLetter: 'l',
    ocl: {
      value: 'fe{pH`I^gBgEIrtXOFw`xHbxyDhhilheDiLjmF\\BVjjjjYfifhbIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSUAMTC~NKA`',
    },
    mass: 379.2831638542993,
    monoisotopicMass: 379.02392259389,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Cau',
    name: '5-carboxymethyl-2-thiouridine monophosphate diradical 2540U',
    mf: 'C11H13N2O9PS',
    kind: 'NucleotideP',
    oneLetter: '℘',
    ocl: {
      value: 'fe{QH`I^aSbdyZNXOFw`xHbxyDhhilheDiLjmF\\BVjjjjYfifhbIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSUAMTC~NKA`',
    },
    mass: 380.26792481311594,
    monoisotopicMass: 380.00793817680005,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Tau',
    name: '5-taurinomethyl-2-thiouridine monophosphate diradical 254U',
    mf: 'C12H18N3O10PS2',
    kind: 'NucleotideP',
    oneLetter: '∃',
    ocl: {
      value:
        'fgpj`I^{BgEIrwY{`|[^C`bKblHrIQQSYQJIRYUYIRLxDmUUUTsMSUKTQDqBId@@',
      coordinates:
        '!BKAb@tURD@m\\YpMAMpBYMcx`BKB]~@Ha}SXW@h`Bb@IMcx}RtDvH_Xa}b@JH@ha}b@JH__rH_]^H_P',
    },
    mass: 459.3892600220213,
    monoisotopicMass: 459.01712313635005,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 2 },
    ],
  },
  {
    symbol: 'Itu',
    name:
      '5-(isopentenylaminomethyl)-2-thiouridine monophosphate diradical 2583U',
    mf: 'C15H22N3O7PS',
    kind: 'NucleotideP',
    oneLetter: '½',
    ocl: {
      value: 'fkoqp`I^{BgEIrtGc[p\\DQ\\\\bTTTvTRbTfUVRTYpIZjjjifZfijbHfHQL`@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lIwx@`H{W@h`BKB_W_Wx@_`@lIr\\SFBrH@h`B_`BH_Xc|bGvH@gx@bGt',
    },
    mass: 419.3902285493682,
    monoisotopicMass: 419.09160823216,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 22 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Mth',
    name: '5-methyl-2-thiouridine monophosphate diradical 25U',
    mf: 'C10H13N2O7PS',
    kind: 'NucleotideP',
    oneLetter: 'F',
    ocl: {
      value: 'fncQp`I^aSbdyZCqmxNBHnNQJJJ[JIQJSJlxDmUUUTsMSQDSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@',
    },
    mass: 336.25837906774416,
    monoisotopicMass: 336.01810893766003,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Dmg',
    name: 'N2,7-dimethylguanosine monophosphate diradical 27G',
    mf: 'C12H18N5O7P',
    kind: 'NucleotideP',
    oneLetter: '∨',
    ocl: {
      value: 'fmwisBINCt\\J\\TgLp^MoBKbFY}dRbbfrbTRdRUbKN^CWmUUUUKLuUUDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RqdCQ@B\\StPAOT`',
    },
    mass: 375.27487685970397,
    monoisotopicMass: 375.0943849377,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dma',
    name: '2,8-dimethyladenosine monophosphate diradical 28A',
    mf: 'C12H16N5O6P',
    kind: 'NucleotideP',
    oneLetter: '±',
    ocl: {
      value: 'feghs@INCv\\J\\UdhOFw`eqrIQQSYQJJJQKqLyxK^uUUUPMLAUADSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpP@c`a}_S_|BD}RSuKQ@B\\StP@',
    },
    mass: 357.2595904272741,
    monoisotopicMass: 357.08382025367,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mas',
    name: '2-methyladenosine monophosphate diradical 2A',
    mf: 'C11H14N5O6P',
    kind: 'NucleotideP',
    oneLetter: '/',
    ocl: {
      value: 'fi{hs@INBt\\J\\TgHOFwaEqrIQQSYQJIRINIgOAjvjjjjAf@j`bIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtP@gD}D@',
    },
    mass: 343.2329730224273,
    monoisotopicMass: 343.06817018921,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Tcy',
    name: '2-thiocytidine monophosphate diradical 2C',
    mf: 'C9H12N3O6PS',
    kind: 'NucleotideP',
    oneLetter: '%',
    ocl: {
      value: 'ff}pp`I^kBgEIrCqmxNBHnNQJJJ[JIQJSMg@ejjjjfYfhbIbDSH@',
      coordinates: '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuP',
    },
    mass: 321.2470007040807,
    monoisotopicMass: 321.01844329029,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Nmg',
    name: 'N2-methylguanosine monophosphate diradical 2G',
    mf: 'C11H14N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'L',
    ocl: {
      value: 'fegis@INBwlJ\\TgHp^MoBKcdRbbfrbTRdR\\VYspZmjjjjiYfijbHfHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtP@gD}D@SuH',
    },
    mass: 359.23237794674554,
    monoisotopicMass: 359.06308480878,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Thu',
    name: '2-thiouridine monophosphate diradical 2U',
    mf: 'C9H11N2O7PS',
    kind: 'NucleotideP',
    oneLetter: '2',
    ocl: {
      value: 'ff}Qp`I^aSbdyjCqmxNBHnNQJJJ[JIQJSMg@ejjjjfYihbIbDSH@',
      coordinates: '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuP',
    },
    mass: 322.2317616628973,
    monoisotopicMass: 322.0024588732,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Ahu',
    name:
      '3-(3-amino-3-carboxypropyl)-5,6-dihydrouridine monophosphate diradical 308U',
    mf: 'C13H20N3O10P',
    kind: 'NucleotideP',
    oneLetter: 'Ð',
    ocl: {
      value: 'fkopk@I^gBgENSens`|[^DWGHeEEMeDheIhueMF\\BVjjjjZfijfhbIbDSH@',
      coordinates:
        '!BTh|SI~ioOwy`iR\\SiV|SFGxw}FH_]]}DqbH@gx_c|SFA`lIqOW_Xa}_c~HHa}_c~H@gx@bGt',
    },
    mass: 409.28630261461393,
    monoisotopicMass: 409.08863085201,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'App',
    name:
      '3-(3-amino-3-carboxypropyl)pseudouridine monophosphate diradical 309U',
    mf: 'C13H18N3O10P',
    kind: 'NucleotideP',
    oneLetter: 'Þ',
    ocl: {
      value: 'fkopk@OAgBgENSens`|[^DWGHeEEMeDheIhueMF\\BVjjjfZfijfhbIbDSH@',
      coordinates:
        '!BTh|SI~ioOwy`iR\\SiV|SFGxw}FH_]]}DqbH@gx_c|SFA`lIqOW_Xa}_c~HHa}_c~H@gx@bGt',
    },
    mass: 407.2704211065024,
    monoisotopicMass: 407.07298078755,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Apu',
    name: '3-(3-amino-3-carboxypropyl)uridine monophosphate diradical 30U',
    mf: 'C13H18N3O10P',
    kind: 'NucleotideP',
    oneLetter: 'X',
    ocl: {
      value: 'fkopk@I^gBgENSens`|[^DWGHeEEMeDheIhueMF\\BVjjjjYfijfhbIbDSH@',
      coordinates:
        '!BTh|SI~ioOwy`iR\\SiV|SFGxw}FH_]]}DqbH@gx_c|SFA`lIqOW_Xa}_c~HHa}_c~H@gx@bGt',
    },
    mass: 407.2704211065024,
    monoisotopicMass: 407.07298078755,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mws',
    name: 'methylwyosine monophosphate diradical 342G',
    mf: 'C15H18N5O7P',
    kind: 'NucleotideP',
    oneLetter: '∑',
    ocl: {
      value:
        'eghZNL@IG@nahJNEDli`OFspb\\\\bTTTvTRbTbb\\rVSGG`SPrvuUUUUKMTsUUIBDpaBX`@',
      coordinates:
        '!B_`CW@mF@ctvDUI|fRxPYgtwP[zV_IorHFY|gD}F@RxPYg|@YgrZOTh{_cuJOS]F@tXAKaI|fw}EMt@',
    },
    mass: 411.3070845499097,
    monoisotopicMass: 411.0943849377,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Uhw',
    name: 'undermodified hydroxywybutosine monophosphate diradical 3470G',
    mf: 'C18H23N6O10P',
    kind: 'NucleotideP',
    oneLetter: 'š',
    ocl: {
      value:
        'ejQVEL@IG@nahXJNEDliolRPOFspb\\\\bTTTvTRbTbb\\rVVTttXx|BZFVvjjjjiYjfZjjfjRDIaBDq@@',
      coordinates:
        '!BKB^@ceS[H`Yg}ARpAeMtHa}KAcPTh{_S]CjXES[pAeMtH}MtEK@IdnDpBXBbES[UMo@F]ARaERH_X`B_`BH_WxbOq~@Ha}',
    },
    mass: 514.3839139947949,
    monoisotopicMass: 514.12132796199,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 18 },
      { symbol: 'H', number: 23 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Acw',
    name: '7-aminocarboxypropylwyosine monophosphate diradical 347G',
    mf: 'C18H23N6O9P',
    kind: 'NucleotideP',
    oneLetter: 'Ω',
    ocl: {
      value:
        'eb^VIL@IG@na`XJNEDlid\\POFspb\\\\bTTTvTRbTbb\\rVRrfcGG`SPrvuUUUUKMTsUUSUIBDpaBX`@',
      coordinates:
        '!BDr]RcwwWpAg_tUS[cm~DUAf_XJUTvx}MaEP@_gwWcm~DUDnDUMo|urH@m_@FWwW_]^NwuS[bGtYgx`BbGu~Ox`B_`BH_P',
    },
    mass: 498.38450907047655,
    monoisotopicMass: 498.12641334242,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 18 },
      { symbol: 'H', number: 23 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hwy',
    name:
      'methylated undermodified hydroxywybutosine monophosphate diradical 3480G',
    mf: 'C19H25N6O10P',
    kind: 'NucleotideP',
    oneLetter: 'y',
    ocl: {
      value:
        'efYVEL@IG@nahXJNEDliolRPOFspb\\\\bTTTvTRbTbb\\rVVTttsGG`SPrvuUUUUKMTsUUTuTdHSBDIb@@',
      coordinates:
        '!B`HyRtL@f_XbDRxz@UHS_chc|S]BN`MAMwxyKaL@fUHS_cmG_chCjXI|YzfA}bL@fpBYTaHz@F\\BH@gx@upJH@ha}_`CWHc|_`@',
    },
    mass: 528.4105313996416,
    monoisotopicMass: 528.1369780264499,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 19 },
      { symbol: 'H', number: 25 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hwb',
    name: 'hydroxywybutosine monophosphate diradical 34830G',
    mf: 'C21H27N6O12P',
    kind: 'NucleotideP',
    oneLetter: '⊆',
    ocl: {
      value:
        'ee[VCL@IG@nahXJNEDliobZV^POFspb\\\\bTTTvTRbTbb\\rVVTtRbfsGG`SPrvuUUUUKMTsUUULuUIBDpaBX`@',
      coordinates:
        '!BKB^@ceS[@h`Yg}ARpAeMtHa}KAcPTh{_S]CjXES[pAeMtH}MtEK@IdnDpBXBbES[UMo@F]ARaERH_X`B_`BH_X`B_c~H_]]}bGu~Ox`B_c~H_P',
    },
    mass: 586.4466945498602,
    monoisotopicMass: 586.14245733005,
    unsaturation: 22,
    elements: [
      { symbol: 'C', number: 21 },
      { symbol: 'H', number: 27 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 12 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Pwb',
    name: 'peroxywybutosine monophosphate diradical 34832G',
    mf: 'C21H27N6O13P',
    kind: 'NucleotideP',
    oneLetter: 'W',
    ocl: {
      value:
        'emWVKL@IG@nadXJNEDliohZV^QPOFspb\\\\bTTTvTRbTbb\\rVVTRfTTvXx|BZFVvjjjjiYjfZjjjYjjRDIaBDq@@',
      coordinates:
        '!BKB^@ceS[@h`Yg}ARpAeMtHa}KAcPTh{_S]CjXES[pAeMtH}MtEK@IdnDpB[|bES[UMo@F]ARaERH_X`B_`BH_X`Bb@I~Oxa}uwvH_Wxb@I~Oxa}',
    },
    mass: 602.4460994741785,
    monoisotopicMass: 602.1373719496199,
    unsaturation: 22,
    elements: [
      { symbol: 'C', number: 21 },
      { symbol: 'H', number: 27 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Wyb',
    name: 'wybutosine monophosphate diradical 3483G',
    mf: 'C21H27N6O11P',
    kind: 'NucleotideP',
    oneLetter: 'Y',
    ocl: {
      value:
        'eiSVML@IG@na`XJNEDlilRZVPOFspb\\\\bTTTvTRbTbb\\rVVRbTTvXx|BZFVvjjjjiYjfZjjfZjdaBXPaLP@',
      coordinates:
        '!BsJ\\@ciP{@`YWuARPAeMT@a}sNaPThxSUCjhIP{PAeMTD}MTEI@IllDPB[|BIP{eCm@FUARAIPH_Pc|BGtHGzBGtw_Pa}_k|HGzBGt',
    },
    mass: 570.4472896255419,
    monoisotopicMass: 570.14754271048,
    unsaturation: 22,
    elements: [
      { symbol: 'C', number: 21 },
      { symbol: 'H', number: 27 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Awo',
    name:
      '7-aminocarboxypropylwyosine methyl ester monophosphate diradical 348G',
    mf: 'C19H25N6O9P',
    kind: 'NucleotideP',
    oneLetter: '⇑',
    ocl: {
      value:
        'ejQVIL@IG@na`XJNEDlid\\POFspb\\\\bTTTvTRbTbb\\rVVRffXx|BZFVvjjjjiYjfZjjZjRDIaBDq@@',
      coordinates:
        '!B`HyRtL@f_XbDRxz@UHS_ch`BS]BN`MAMwxyKaL@fUHS_cmG_chCjXI|YzfA}bL@fpBYTaHz@F\\BHHa}bOq~@Ha}_c~H@ha}',
    },
    mass: 512.4111264753234,
    monoisotopicMass: 512.14206340688,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 19 },
      { symbol: 'H', number: 25 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Wyo',
    name: 'wyosine monophosphate diradical 34G',
    mf: 'C14H16N5O7P',
    kind: 'NucleotideP',
    oneLetter: '€',
    ocl: {
      value:
        'ek`ZNL@IG@nahJNEDli`OFspb\\\\bTTTvTRbTbb\\rVXx|BZFVvjjjjiYjfZjdaBXPaLP@',
      coordinates:
        '!B_`CWMF@ctvDUI|fRxPYgtwP[zV_IorHFY|gD}F@RxPYg|@YgrZOTh{_cuJOS]F@tXAKaI|fw}D',
    },
    mass: 397.2804671450629,
    monoisotopicMass: 397.07873487324,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 14 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Pdu',
    name: '3-methylpseudouridine monophosphate diradical 39U',
    mf: 'C10H13N2O8P',
    kind: 'NucleotideP',
    oneLetter: 'κ',
    ocl: {
      value: 'fncPK@OAaSbgIrtGc[pbxyDhhilheDiMFs`RuUUTsTuMDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@HoWtw@`lFC~NSU@',
    },
    mass: 320.1929965859354,
    monoisotopicMass: 320.04095238282997,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mri',
    name: '3-methyluridine monophosphate diradical 3U',
    mf: 'C10H13N2O8P',
    kind: 'NucleotideP',
    oneLetter: 'δ',
    ocl: {
      value: 'fncPK@I^aSbgIrtGc[pbxyDhhilheDiMFs`RuUUUSLuMDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@HoWtw@`lFC~NSU@',
    },
    mass: 320.1929965859354,
    monoisotopicMass: 320.04095238282997,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Acc',
    name: 'N4-acetylcytidine monophosphate diradical 42C',
    mf: 'C11H14N3O8P',
    kind: 'NucleotideP',
    oneLetter: 'M',
    ocl: {
      value: 'fikpK@I^kBgENSghOFwaEqrIQQSYQJIRYiQg@ejjjjfYffhbIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuPOxxSItuP',
    },
    mass: 347.21837644817225,
    monoisotopicMass: 347.05185141949,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Iws',
    name: 'isowyosine monophosphate diradical 42G',
    mf: 'C14H16N5O7P',
    kind: 'NucleotideP',
    oneLetter: '⊇',
    ocl: {
      value:
        'ek`ZNL@IG@fnhJNEDla`OFspb\\\\bTTTvTRbTbSbRrXx|BjzfVjjjjiYjYjjdaBXPaLP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RStwQ@MD@RpQ_qcQSU@',
    },
    mass: 397.2804671450629,
    monoisotopicMass: 397.07873487324,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 14 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dmc',
    name: 'N4,N4-dimethylcytidine monophosphate diradical 44C',
    mf: 'C11H16N3O7P',
    kind: 'NucleotideP',
    oneLetter: 'μ',
    ocl: {
      value: 'fasqs@I^kBgENSdGc[pbxyDhhilheDiLuF\\BVjjjjYfZjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBGpcbpXBGtSItuPSU@H_Wtw@`lFDuPOxxlF@',
    },
    mass: 333.23485303196554,
    monoisotopicMass: 333.07258686438,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Adw',
    name: '7-aminocarboxypropyl-demethylwyosine monophosphate diradical 47G',
    mf: 'C17H21N6O9P',
    kind: 'NucleotideP',
    oneLetter: '¥',
    ocl: {
      value:
        'elVVIL@IG@fnohJNEDlahTPOFspb\\\\bTTTvTRbTbSbRrrTtXx|BjzfVjjjjiYjYjjijdaBXPaLP@',
      coordinates:
        '!B`MERc|@Y_]^DUH{_UMo_tXa}SXPTh{_w}GjXES[pAg_t]F@cm@Il@f@haTvuS[pAgPThQTbGvH@ha}_c~HGx@bGt',
    },
    mass: 484.3578916656298,
    monoisotopicMass: 484.1107632779601,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 17 },
      { symbol: 'H', number: 21 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ncd',
    name: 'N4-methylcytidine monophosphate diradical 4C',
    mf: 'C10H14N3O7P',
    kind: 'NucleotideP',
    oneLetter: 'ν',
    ocl: {
      value: 'fncqs@I^kBgENSdGc[pbxyDhhilheDiLts`RuUUUSLsUDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuPKA`',
    },
    mass: 319.2082356271187,
    monoisotopicMass: 319.05693679992004,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dmw',
    name: '4-demethylwyosine monophosphate diradical 4G',
    mf: 'C13H14N5O7P',
    kind: 'NucleotideP',
    oneLetter: '†',
    ocl: {
      value: 'fcis@INBwlJ\\TgHp^MoBKcdRbbfrbTRdR\\RVYspZ}fnjjjjefifjiHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RStwQ@MD@RpQ_qcQ',
    },
    mass: 383.253849740216,
    monoisotopicMass: 383.06308480878,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mtu',
    name: '5-methoxyuridine monophosphate diradical 501U',
    mf: 'C10H13N2O9P',
    kind: 'NucleotideP',
    oneLetter: '5',
    ocl: {
      value: 'fasQK@I^aSbgIsUhOFwaEqrIQQSYQJIRYULxDmUUUTsMSTQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tP',
    },
    mass: 336.19240151025366,
    monoisotopicMass: 336.03586700240004,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Uoa',
    name: 'uridine 5-oxyacetic acid monophosphate diradical 502U',
    mf: 'C11H13N2O11P',
    kind: 'NucleotideP',
    oneLetter: 'V',
    ocl: {
      value: 'fmgQk@I^aSbgIsUlu`|[^DWGHeEEMeDheIeUeF\\BVjjjjYfiijHbXaDr@@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lIwx@`H{WHc|KB_W_Wx@_`@lIr\\SFBrHHc|_`BH_Xc|_`BH_P',
    },
    mass: 380.2019472556255,
    monoisotopicMass: 380.02569624154,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ume',
    name: 'uridine 5-oxyacetic acid methyl ester monophosphate diradical 503U',
    mf: 'C12H15N2O11P',
    kind: 'NucleotideP',
    oneLetter: 'υ',
    ocl: {
      value: 'fcwQk@I^aSbgIsUlu`|[^DWGHeEEMeDheIeUeLs`RuUUUSLuMMTQDqBId@@',
      coordinates:
        '!BKAb@tURDM\\YpMAMpBYMcxc|KB]~@Ha}SXWHc|bOqMcx}RtDvH_Xa}bOrH@ha}_c~HHa}',
    },
    mass: 394.2285646604723,
    monoisotopicMass: 394.041346306,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hxc',
    name: '5-hydroxycytidine monophosphate diradical 50C',
    mf: 'C9H12N3O8P',
    kind: 'NucleotideP',
    oneLetter: 'Ç',
    ocl: {
      value: 'fncpK@I^[BgENSfhOFwaEqrIQQSYQJIRYUg@ejjjjfYfjHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@',
    },
    mass: 321.1810231465902,
    monoisotopicMass: 321.03620135502996,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hxu',
    name: '5-hydroxyuridine monophosphate diradical 50U',
    mf: 'C9H11N2O9P',
    kind: 'NucleotideP',
    oneLetter: '∝',
    ocl: {
      value: 'fncQK@I^aSbgIsUhOFwaEqrIQQSYQJIRYUg@ejjjjfYjZHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@',
    },
    mass: 322.1657841054069,
    monoisotopicMass: 322.02021693794,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Amu',
    name: '5-aminomethyluridine monophosphate diradical 510U',
    mf: 'C10H14N3O8P',
    kind: 'NucleotideP',
    oneLetter: '∪',
    ocl: {
      value: 'faspK@I^{BgENSehOFwaEqrIQQSYQJIRYULxDmUUUTsMSTQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tP',
    },
    mass: 335.207640551437,
    monoisotopicMass: 335.05185141949,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mau',
    name: '5-methylaminomethyluridine monophosphate diradical 511U',
    mf: 'C11H16N3O8P',
    kind: 'NucleotideP',
    oneLetter: '{',
    ocl: {
      value: 'fikpK@I^{BgENSehOFwaEqrIQQSYQJIRYUYg@ejjjjfYjZhbIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSUAMTBpX',
    },
    mass: 349.2342579562838,
    monoisotopicMass: 349.06750148395,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hmc',
    name: '5-hydroxymethylcytidine monophosphate diradical 51C',
    mf: 'C10H14N3O8P',
    kind: 'NucleotideP',
    oneLetter: '∅',
    ocl: {
      value: 'faspK@I^[BgENSghOFwaEqrIQQSYQJIRYULxDmUUUTsLuTQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tP',
    },
    mass: 335.207640551437,
    monoisotopicMass: 335.05185141949,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Cur',
    name: '5-carboxymethylaminomethyluridine monophosphate diradical 51U',
    mf: 'C12H16N3O10P',
    kind: 'NucleotideP',
    oneLetter: '!',
    ocl: {
      value: 'fcwpk@I^{BgENSej}`|[^DWGHeEEMeDheIeUdhs`RuUUUSLuMSTQDqBId@@',
      coordinates:
        '!BKAb@tURDM\\YpMAMpBYMcx`BKB]~@Ha}SXW@h`Bb@IMcx}RtDvH_Xa}b@JH@ha}b@I~@Ha}',
    },
    mass: 393.24380370165557,
    monoisotopicMass: 393.05733072309,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Chr',
    name: '5-carboxyhydroxymethyluridine monophosphate diradical 520U',
    mf: 'C11H13N2O11P',
    kind: 'NucleotideP',
    oneLetter: '≥',
    ocl: {
      value: 'fmgQk@I^aSbgIrwlu`|[^DWGHeEEMeDheIeUCF\\BVjjjjYfiijHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tTuPOxxlF@',
    },
    mass: 380.2019472556255,
    monoisotopicMass: 380.02569624154,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mcu',
    name: '5-methoxycarbonylmethyluridine monophosphate diradical 521U',
    mf: 'C12H15N2O10P',
    kind: 'NucleotideP',
    oneLetter: '1',
    ocl: {
      value: 'fmgPk@I^aSbgIrt\\p^MoBKcdRbbfrbTRdrjtsNAKUUUULsTsUDQLPbY@@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lIwx@`H{WHc|KB_W_Wx@_`@lIr\\SFBrH@h`B_`BH_WxbOrH_P',
    },
    mass: 378.229159736154,
    monoisotopicMass: 378.04643168643,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hme',
    name:
      '5-(carboxyhydroxymethyl)uridine methyl ester monophosphate diradical 522U',
    mf: 'C12H15N2O11P',
    kind: 'NucleotideP',
    oneLetter: ',',
    ocl: {
      value: 'fcwQk@I^aSbgIrwlu`|[^DWGHeEEMeDheIeUCLs`RuUUUSLuMMTQDqBId@@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lIwx@`H{WHc|KB_W_Wx@_`@lIr\\SFBrHHc|_`A~@Ha}_c~H@ha}',
    },
    mass: 394.2285646604723,
    monoisotopicMass: 394.041346306,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Cxu',
    name: '5-carboxymethyluridine monophosphate diradical 52U',
    mf: 'C11H13N2O10P',
    kind: 'NucleotideP',
    oneLetter: '◊',
    ocl: {
      value: 'fe{Pk@I^aSbgIrt\\p^MoBKcdRbbfrbTRdrjtYpIZjjjifZfZbHfHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSUAMTC~NKA`',
    },
    mass: 364.2025423313072,
    monoisotopicMass: 364.03078162197,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hmu',
    name: '5-carbamoylhydroxymethyluridine monophosphate diradical 531U',
    mf: 'C11H14N3O10P',
    kind: 'NucleotideP',
    oneLetter: 'r',
    ocl: {
      value: 'fmgpk@I^WBgENSeoY`|[^DWGHeEEMeDheIeUCF\\BVjjjjYfiijHbXaDr@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tTuPOxxlF@',
    },
    mass: 379.21718629680873,
    monoisotopicMass: 379.04168065863,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ymu',
    name: '5-carbamoylmethyluridine monophosphate diradical 53U',
    mf: 'C11H14N3O9P',
    kind: 'NucleotideP',
    oneLetter: '&',
    ocl: {
      value: 'fe{qK@I^gBgENSehp^MoBKcdRbbfrbTRdrjtYpIZjjjifZfZbHfHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSUAMTC~NKA`',
    },
    mass: 363.2177813724905,
    monoisotopicMass: 363.04676603906006,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ttu',
    name: '5-taurinomethyluridine monophosphate diradical 54U',
    mf: 'C12H18N3O11PS',
    kind: 'NucleotideP',
    oneLetter: 'Ê',
    ocl: {
      value: 'fgqh`I^{BgENSenswAxv|HnJpcHeEEMeDheIeUdeHs`RuUUUSLuMTmQDSDHfP@',
      coordinates:
        '!BKAb@tURD@m\\YpMAMpBYMcx`BKB]~@Ha}SXW@h`Bb@IMcx}RtDvH_Xa}b@JH@ha}b@JH__rH_]^H_P',
    },
    mass: 443.32387754021244,
    monoisotopicMass: 443.03996658152005,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Cmu',
    name: '5-cyanomethyluridine monophosphate diradical 55U',
    mf: 'C11H12N3O8P',
    kind: 'NucleotideP',
    oneLetter: 'Ѷ',
    ocl: {
      value: 'fikpK@I^GBgENSehOFwaEqrIQQSYQJIRYUYg@ejjjjfYj[hbIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tPCQ',
    },
    mass: 345.20249494006066,
    monoisotopicMass: 345.03620135502996,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Pyu',
    name: '5-(isopentenylaminomethyl)uridine monophosphate diradical 583U',
    mf: 'C15H22N3O8P',
    kind: 'NucleotideP',
    oneLetter: '¾',
    ocl: {
      value: 'fkopK@I^{BgENSehOFwaEqrIQQSYQJIRYUYIQg@ejjjjfYjZfjHbXaDr@@',
      coordinates:
        '!BS]@lFJU`@Gyoza`lzf@lIwx@`H{W@h`BKB_W_Wx@_`@lIr\\SFBrH@h`B_`BH_Xc|bGvH@gx@bGt',
    },
    mass: 403.32484606755946,
    monoisotopicMass: 403.11445167733,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 22 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mdu',
    name: '5-methyldihydrouridine monophosphate diradical 58U',
    mf: 'C10H15N2O8P',
    kind: 'NucleotideP',
    oneLetter: 'ρ',
    ocl: {
      value: 'fncPK@I^aSbgIrtGc[pbxyDhhilheDiLjs`RuUUUSTuMDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@',
    },
    mass: 322.20887809404695,
    monoisotopicMass: 322.05660244729,
    unsaturation: 8,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mcd',
    name: '5-methylcytidine monophosphate diradical 5C',
    mf: 'C10H14N3O7P',
    kind: 'NucleotideP',
    oneLetter: '?',
    ocl: {
      value: 'fncqs@I^[BgENSdGc[pbxyDhhilheDiLjs`RuUUUSLsUDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@',
    },
    mass: 319.2082356271187,
    monoisotopicMass: 319.05693679992004,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hia',
    name: 'N6-(cis-hydroxyisopentenyl)adenosine monophosphate diradical 60A',
    mf: 'C15H20N5O7P',
    kind: 'NucleotideP',
    oneLetter: '`',
    ocl: {
      value:
        'eg`ZNL@IG@fnhJNEDlk`OFspb\\\\bTTTvTRbTbSVRTSGG`USUUUUTCLATuTDHSBDIbPSH',
      coordinates:
        '!BzfC@IeKPaDn}bHCQb@KQwuRDFALYpHCQt]W@h`BTmCQw}~N`ME~@Gx@b@JH@ha}bOrH_Wxb@JH_P',
    },
    mass: 413.3229660580212,
    monoisotopicMass: 413.11003500216003,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 20 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mta',
    name: '2-methylthio-N6-methyladenosine monophosphate diradical 621A',
    mf: 'C12H16N5O6PS',
    kind: 'NucleotideP',
    oneLetter: '∞',
    ocl: {
      value: 'fmwhp`CQstZLDxipEfGa[qZDYEIlheDdhXdmDmKR\\u{MUUUU@aEUAFPTdmH@',
      coordinates:
        '!BBGw|B@a}_S\\H@a}TEJNOuP{Ntm@fPBN[~iRSpHUCneXDBYTEITAEPDiVA@fTBYU@Sj[p',
    },
    mass: 389.3243778334011,
    monoisotopicMass: 389.05589142807,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Tca',
    name: 'N6-threonylcarbamoyladenosine monophosphate diradical 62A',
    mf: 'C15H19N6O10P',
    kind: 'NucleotideP',
    oneLetter: '6',
    ocl: {
      value:
        'edRVEL@IG@fnehJNEDligo`POFspb\\\\bTTTvTRbTbSVTrbbcGG`USUUUUTCLASUMUABDpaBX`@',
      coordinates:
        '!BzfC@IeKPaDn}bHCQbOsQwuRDFALYpHCQt]W@h`BTmCQw}~N`ME~@Gx@b@JH@ha}_c~H@ha}_c~H@ha}uwu~@Ha}',
    },
    mass: 474.31994328836606,
    monoisotopicMass: 474.09002783307,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 19 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hva',
    name: 'N6-hydroxynorvalylcarbamoyladenosine monophosphate diradical 63A',
    mf: 'C16H21N6O10P',
    kind: 'NucleotideP',
    oneLetter: '√',
    ocl: {
      value:
        'elZVIB@IG@fnehJNDligo`POEQql|HgGHeEEMeDheHdueLhhiVNO@jfjjjjhFXBfjZj`aBXPaLP@',
      coordinates:
        '!BpBYTvxBNFY|bEJObGvOS\\@Yt]~DUEJOctu~@Ha}`HzOSTwPTh~HH`BbGvH_Xc|_`BH_Xc|_`BH_]_|bOq~Oxc|bGt',
    },
    mass: 488.34656069321284,
    monoisotopicMass: 488.10567789753003,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 16 },
      { symbol: 'H', number: 21 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Aya',
    name: 'N6-acetyladenosine monophosphate diradical 64A',
    mf: 'C12H14N5O7P',
    kind: 'NucleotideP',
    oneLetter: '⇓',
    ocl: {
      value: 'fmwis@INBwlJ\\TgLp^MoBKcdRbbfrbTRdRZrcN^CUmUUUTCLASTDQLPbY@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtPCQ@D}RIqOQ@@',
    },
    mass: 371.2431138434808,
    monoisotopicMass: 371.06308480878,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Gca',
    name: 'N6-glycinylcarbamoyladenosine monophosphate diradical 65A',
    mf: 'C13H15N6O9P',
    kind: 'NucleotideP',
    oneLetter: '≡',
    ocl: {
      value:
        'eohVIL@IG@fnehJNEDlikg`OFspb\\\\bTTTvTRbTbSVTrTXx|BjZjjjj`Y`JZfhHPfDHSD@@',
      coordinates:
        '!BzfC@IeKPaDn}bHCQb@KQwuRDFALYpHCQt]W@h`BTmCQw}~N`ME~@Gx@bOrHHa}_c~H@ha}bOq~@Ha}',
    },
    mass: 430.2673035543541,
    monoisotopicMass: 430.06381308458,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Tya',
    name: 'N6-methyl-N6-threonylcarbamoyladenosinemonophosphate diradical 662A',
    mf: 'C16H21N6O10P',
    kind: 'NucleotideP',
    oneLetter: 'E',
    ocl: {
      value:
        'elZVEL@IG@fnmhJNEDleo`XPOFspb\\\\bTTTvTRbTbSVbaTTTXx|BjZjjjj`Y`JfjZjBDIaBDq@@',
      coordinates:
        '!BzfC@IeKPaDn}bHCQb@KQwuRDFALYpHCQt]W@h`BTmCQw}~N`ME~@Gx@bOrHHa}_`A~Ox`BbGu~Ox`BbGwW_Wx@bGt',
    },
    mass: 488.34656069321284,
    monoisotopicMass: 488.10567789753003,
    unsaturation: 18,
    elements: [
      { symbol: 'C', number: 16 },
      { symbol: 'H', number: 21 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Nna',
    name: 'N6,N6-dimethyladenosine monophosphate diradical 66A',
    mf: 'C12H16N5O6P',
    kind: 'NucleotideP',
    oneLetter: 'ζ',
    ocl: {
      value: 'feghs@INBwlJ\\TgHOFwaEqrIQQSYQJIRIMZLyxMVuUUUPLpEUADSDHfP@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtPCQ@D}RFBp',
    },
    mass: 357.2595904272741,
    monoisotopicMass: 357.08382025367,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Fya',
    name: 'N6-formyladenosine monophosphate diradical 67A',
    mf: 'C11H12N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'Ϩ',
    ocl: {
      value: 'fegis@INBwlJ\\TgLp^MoBKcdRbbfrbTRdRZrYspZmjjjj`Y`JZBHfHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtPCQ@D}RtP@',
    },
    mass: 357.216496438634,
    monoisotopicMass: 357.04743474432,
    unsaturation: 16,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Hma',
    name: 'N6-hydroxymethyladenosine monophosphate diradical 68A',
    mf: 'C11H14N5O7P',
    kind: 'NucleotideP',
    oneLetter: 'Ϫ',
    ocl: {
      value: 'fegis@INBwlJ\\TgLp^MoBKcdRbbfrbTRdRZrYspZmjjjj`Y`JjBHfHQL`@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtPCQ@D}RtP@',
    },
    mass: 359.23237794674554,
    monoisotopicMass: 359.06308480878,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Cca',
    name: 'cyclic N6-threonylcarbamoyladenosine monophosphate diradical 69A',
    mf: 'C15H17N6O9P',
    kind: 'NucleotideP',
    oneLetter: 'e',
    ocl: {
      value:
        'ehRVIL@IG@fnehJNEDliko`OFspb\\\\bTTTvTRbTbSVTRRtXx|BjZvNjjjj`Y`IjfjbHPfDHSD`z`',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@J_IorHbGtgD}F@RxRH_WwW@hbOTh}RtXCQ`A`l_`A`iVCjKAcjX@A~@h`Bup',
    },
    mass: 456.30465685593623,
    monoisotopicMass: 456.07946314904,
    unsaturation: 20,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 17 },
      { symbol: 'N', number: 6 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Fcy',
    name: '5-formylcytidine monophosphate diradical71C',
    mf: 'C10H12N3O8P',
    kind: 'NucleotideP',
    oneLetter: '>',
    ocl: {
      value: 'faspK@I^[BgENSghOFwaEqrIQQSYQJIRYULxDmUUUTsLttQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFBpXSU@@tP',
    },
    mass: 333.1917590433254,
    monoisotopicMass: 333.03620135502996,
    unsaturation: 12,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Tur',
    name: '4-thiouridine monophosphate diradical 74U',
    mf: 'C9H11N2O7PS',
    kind: 'NucleotideP',
    oneLetter: '4',
    ocl: {
      value: 'ff}Qp`I^aSbgIrCqmxQ\\ZaFQJJJ[JIQJSMg@ejjjjfYihbIbDSH@',
      coordinates: '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuP',
    },
    mass: 322.2317616628973,
    monoisotopicMass: 322.0024588732,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Meg',
    name: '7-methylguanosine monophosphate diradical 7G',
    mf: 'C11H15N5O7P',
    kind: 'NucleotideP',
    oneLetter: '7',
    ocl: {
      value: 'fegisDINCt\\J\\TgLp^MoBKbF\\bTTTvTRbTbRlSN^CWmUUUUKLuSTQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RqdCQ@B\\StP@',
    },
    mass: 360.2403187008013,
    monoisotopicMass: 360.07090984101,
    unsaturation: 13,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mea',
    name: '8-methyladenosine monophosphate diradical 8A',
    mf: 'C11H14N5O6P',
    kind: 'NucleotideP',
    oneLetter: 'â',
    ocl: {
      value: 'fi{hs@INCt\\J\\UdhOFw`eqrIQQSYQJJJQKigOA[vjjjjAi`J`bIbDSH@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpP@c`a}_S_|BD}RSuKQ@MD@',
    },
    mass: 343.2329730224273,
    monoisotopicMass: 343.06817018921,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Dhu',
    name: 'dihydrouridine monophosphate diradical 8U',
    mf: 'C9H13N2O8P',
    kind: 'NucleotideP',
    oneLetter: 'D',
    ocl: {
      value: 'ff}PK@I^aSbgIsTGc[pbxyDhhilheDiLv\\BVjjjjZffbHfHQL`@',
      coordinates: '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuP',
    },
    mass: 308.1822606892002,
    monoisotopicMass: 308.04095238282997,
    unsaturation: 8,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Ins',
    name: 'inosine monophosphate diradical 9A',
    mf: 'C10H11N4O7P',
    kind: 'NucleotideP',
    oneLetter: 'I',
    ocl: {
      value: 'fakIs@INBvENJSghOFwaEqrIQQSYQJIRIMLyxMVuUUUTlsSTQDqBId@@',
      coordinates:
        '!BNuSFPDlDTEHt_pHtP@H_TuPBOq_qopHBGtgD}D@RpPH_Wtw@aOTd}RtPCQ@@',
    },
    mass: 330.1911165763972,
    monoisotopicMass: 330.03653570766,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 4 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Pis',
    name: 'pseudouridine monophosphate diradical 9U',
    mf: 'C9H11N2O8P',
    kind: 'NucleotideP',
    oneLetter: 'P',
    ocl: {
      value: 'ff}PK@OAaSbgIsTGc[pbxyDhhilheDiLv\\BVjjjfZffbHfHQL`@',
      coordinates: '!BNuSFPDlDTEHt_pHtP@H_TuPBOpcbpXBGtSItuPSU@H_Wtw@`lFDuP',
    },
    mass: 306.1663791810886,
    monoisotopicMass: 306.02530231837,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Pqb',
    name: 'preQ0base 100G diradical (base)',
    mf: 'C7H5N5O',
    kind: 'Nucleotide',
    oneLetter: 'ψ',
    ocl: {
      value: 'dk^h@DxYLLbbTTRekiujYj^`@',
      coordinates: '!B|Gwp_Gy|Gwp_[lk_gp_Ag_wrYRs}|f',
    },
    mass: 175.1477760289729,
    monoisotopicMass: 175.04940980287,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Pqg',
    name: 'preQ1base 101G diradical (base)',
    mf: 'C7H9N5O',
    kind: 'Nucleotide',
    oneLetter: '∇',
    ocl: {
      value: 'dk^h@DxYLLbbTTRckiUjYij`@',
      coordinates: '!BWyfe[tlDWye_fXx@RpRe[wtHSuHH@a}',
    },
    mass: 179.179539045196,
    monoisotopicMass: 179.08070993179,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 1 },
    ],
  },
  {
    symbol: 'Qba',
    name: 'Qbase 10G diradical (base)',
    mf: 'C12H15N5O3',
    kind: 'Nucleotide',
    oneLetter: '∴',
    ocl: {
      value: 'fbmi`@D\\EHpHyrJIQQJMJIPtyIPTmSMMUMUP@@',
      coordinates: '!BRpQ_f^i`RpQKAEARzfA_f_pHtP@H_Pc|BGuPThxUCl{RtBYTd|',
    },
    mass: 277.27967290184347,
    monoisotopicMass: 277.11748936431,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 3 },
    ],
  },
  {
    symbol: 'Dgc',
    name: 'N2,7-dimethylguanosine cap (cap DMG) diradical 279553N',
    mf: 'C12H18N5O11P2',
    kind: 'Nucleotide',
    oneLetter: '®',
    ocl: {
      value:
        'e`TZMBHIG@aihJNEHdlemck`OFspz|OgDJ\\bTTTvTRbTbRvbtfKGG`UPuUUUUJtuTmUTPaLHPfH@@',
      coordinates:
        '!BvuPfpDnDtEK_t_rHtXBH_TwPbOr_IorHbGtgD}F@RxS|uxc|_]^OTh}RIlBH_]F@IqOQ`@A~_c|bH}RbGt',
    },
    mass: 470.24625855539705,
    monoisotopicMass: 470.04780541440005,
    unsaturation: 13,
    elements: [
      { symbol: 'C', number: 12 },
      { symbol: 'H', number: 18 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Dpa',
    name: '5′-(3′-dephosphoacetyl-CoA) diradical 4155N',
    mf: 'C23H35N7O16P3S',
    kind: 'Nucleotide',
    oneLetter: '♣',
    ocl: {
      value:
        'elz~@jDCHlemnSTLBAEKBjfckgbV]XpEfCpB|IoCtHZy{lbdvbbfrbTRdRNRdnTbefRTrRTdTRrFVfjjjj`V`bZjjfjZjZ`bbLSaRP@',
      coordinates:
        '!BvtmKaMmKUMlfgto[tDw_cosWt]~H@dvObGv_F_sWbOpgKMG_R}m}bHa}HbOSX}M_cQw}G_OwzH_[wW_c~H_Wx@G{|bM]}bGvHGxbGu~Oxa}bOq~Oxa}_c~H_WxuwvH_P',
    },
    mass: 790.5483266874629,
    monoisotopicMass: 790.1073852418399,
    unsaturation: 21,
    elements: [
      { symbol: 'C', number: 23 },
      { symbol: 'H', number: 35 },
      { symbol: 'N', number: 7 },
      { symbol: 'O', number: 16 },
      { symbol: 'P', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Dpm',
    name: '5′-(3′-dephosphomalonyl-CoA) diradical 4255N',
    mf: 'C24H35N7O18P3S',
    kind: 'Nucleotide',
    oneLetter: '♥',
    ocl: {
      value:
        'efq~DjDCHlemnSTLBAEKBjfckgbV]XrzpEfCpB|IoCtHZy{lbdvbbfrbTRdRNRdnTbefRTrRTrdbbVPrtuUUUTBtDSUUTuSUSSTDTQb\\JR@@',
      coordinates:
        '!BIlB_Ib[@pAe`zni`FALSF@A~FBq~OrpXbGveX@A~_c~OTa`lzf@_ha}_]_Q`MF@bOpXKA`loXbH__rHb@JHoX`B@m]}uwx@bGu~Ox`BbKvH@ha}_c~H@hb}b@JH_Xc|_`BH_X`B_`BHoP',
    },
    mass: 834.5578724328346,
    monoisotopicMass: 834.0972144809799,
    unsaturation: 23,
    elements: [
      { symbol: 'C', number: 24 },
      { symbol: 'H', number: 35 },
      { symbol: 'N', number: 7 },
      { symbol: 'O', number: 18 },
      { symbol: 'P', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Dsc',
    name: '5′-(3′-dephosphosuccinyl-CoA) radical 4355N',
    mf: 'C25H37N7O18P3S',
    kind: 'Nucleotide',
    oneLetter: '♦',
    ocl: {
      value:
        'eny~DjDCHlemnSTLBAEKBjfckgbV]XzvpOFCpB|IoCtHZy{lbdvbbfrbTRdRNRdnTbefRTrRTrTdTRrFVfjjjj`V`bZjjfjZjZfhHhcDxTd@@',
      coordinates:
        '!B[~kjXFjiV[Ry|fcm}MtGwWctvH_]Q_c}KaGwWbGvN`H}MgrX@_gx@h`gKB\\lbGvOSX}M@m^H@gwWbGvH@ha}_Xc|bGxb@I~@Ha}b@JH_X`B_`BH_X`BbGvH@ha}_c~H@ha}b@I~@Ha}',
    },
    mass: 848.5844898376815,
    monoisotopicMass: 848.11286454544,
    unsaturation: 23,
    elements: [
      { symbol: 'C', number: 25 },
      { symbol: 'H', number: 37 },
      { symbol: 'N', number: 7 },
      { symbol: 'O', number: 18 },
      { symbol: 'P', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Dpc',
    name: '5′-(3′-dephospho-CoA) radical 455N',
    mf: 'C21H32N7O13P2S',
    kind: 'Nucleotide',
    oneLetter: '♠',
    ocl: {
      value:
        'ek_^KBDIG@nabYXJNEHdliemh\\QPEfspZ|CPcKmnrIQQSYQJIRIGIRWJQRsIJYIccpJkjjjjjAZBIjjjZijjBDIaBDq@@',
      coordinates:
        '!B[zW[UI|YchAMc{vHcuJH@m~NbGuKvwvHb@JNwx}Rgqe}bHa}@h`gDr\\Sb@JOTh}R@m]~@@A~b@I~@H`B_X`_hb}_`CW@h`B_`BH@gx@upJH@gx@b@I~@@',
    },
    mass: 684.5310558604504,
    monoisotopicMass: 684.1254042880199,
    unsaturation: 19,
    elements: [
      { symbol: 'C', number: 21 },
      { symbol: 'H', number: 32 },
      { symbol: 'N', number: 7 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 2 },
      { symbol: 'S', number: 1 },
    ],
  },
  {
    symbol: 'Dpe',
    name: '5′-diphosphate end 552N',
    mf: 'O3P',
    kind: 'Nucleotide',
    oneLetter: 'ϒ',
    ocl: { value: 'gJQdebGF^Dx|duK@@', coordinates: '!BbOq~@GxbGt' },
    mass: 78.97197677137483,
    monoisotopicMass: 78.95850585713,
    unsaturation: 1,
    elements: [
      { symbol: 'O', number: 3 },
      { symbol: 'P', number: 1 },
    ],
  },
  {
    symbol: 'Mgc',
    name: '7-methylguanosine cap (cap 0) diradical 79553N',
    mf: 'C11H16N5O11P2',
    kind: 'Nucleotide',
    oneLetter: '©',
    ocl: {
      value:
        'eohZMBHIG@aihJNEHdlemck`OFspz|GgDJ\\bTTTvTRbTbRvbtcXx|BjFjjjjiVfjejjHPfDHSD@@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@J_I`JHbGtgD}F@RxPBux`B_]^OTh}RIlBH_]F@IqOQ`@A~_c|BbHa}',
    },
    mass: 456.2196411505502,
    monoisotopicMass: 456.03215534994,
    unsaturation: 13,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 16 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Gyy',
    name: 'guanylylated 5′ end (cap G) diradical 9553N',
    mf: 'C10H13N5O10P2',
    kind: 'Nucleotide',
    oneLetter: 'ϑ',
    ocl: {
      value:
        'fkhh`INCt\\J\\UENY{NCqmxM|EnNQJJJ[JIQJQHzIRLyxM^uUUUTkSULuQDSDHfP@',
      coordinates:
        '!BvuPfpDnDtEK_tPJHtXBH_TwPb@J_I`JHbGtgD}F@RxPBux`B_]^OTh}R_`CQ`B\\StXA~@C}~@Gx',
    },
    mass: 425.1856780673293,
    monoisotopicMass: 425.01376563368,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  {
    symbol: 'Furp',
    name: 'furan phosphate radical',
    mf: 'C5H6O4P',
    kind: 'RNAp',
    oneLetter: '⬠',
    ocl: {
      value: 'dmtBPDpnAYcpRZ}eeYjii@@',
      coordinates: '!B]w|Mw\\B_S]wW\\BtP@oKS~frpP',
    },
    mass: 161.072705703704,
    monoisotopicMass: 161.00037067008,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 6 },
      { symbol: 'O', number: 4 },
      { symbol: 'P', number: 1 },
    ],
  },
];
